"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DwebgMessage = void 0;
/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 3.21.5
 * source: tmp3_vykvbe_message.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
const dependency_1 = __importStar(require("./google/protobuf/struct"));
const dependency_2 = __importStar(require("./google/protobuf/timestamp"));
const dependency_3 = __importStar(require("./google/protobuf/duration"));
const pb_1 = __importStar(require("google-protobuf"));
var DwebgMessage;
(function (DwebgMessage) {
    var _AuthRequest_one_of_decls, _Request_one_of_decls, _CloseSession_one_of_decls, _Response_one_of_decls, _CancelBatchQueryError_one_of_decls, _GetUploadUrl_one_of_decls, _GetUploadUrlResponse_one_of_decls, _GetUploadUrlError_one_of_decls, _GetSessionToken_one_of_decls, _LoginCredentials_one_of_decls, _SessionTokenStatusChange_one_of_decls, _SessionError_one_of_decls, _AttachSessionToken_one_of_decls, _AttachSessionTokenResponse_one_of_decls, _BatchQuery_one_of_decls, _Query_one_of_decls, _Records_one_of_decls, _QueryResults_one_of_decls, _QueryError_one_of_decls, _CancelBatchQuery_one_of_decls, _ListenChannel_one_of_decls, _Subscribe_one_of_decls, _SubscribeError_one_of_decls, _SubscribeResults_one_of_decls, _CancelSubscribe_one_of_decls, _CancelSubscribeError_one_of_decls, _IdValue_one_of_decls, _Value_one_of_decls, _List_one_of_decls, _Map__one_of_decls;
    let CancelBatchQueryCause;
    (function (CancelBatchQueryCause) {
        CancelBatchQueryCause[CancelBatchQueryCause["CANCEL_BATCH_QUERY_CAUSE_UNKNOWN"] = 0] = "CANCEL_BATCH_QUERY_CAUSE_UNKNOWN";
        CancelBatchQueryCause[CancelBatchQueryCause["CANCEL_BATCH_QUERY_CAUSE_NOT_FOUND"] = 1] = "CANCEL_BATCH_QUERY_CAUSE_NOT_FOUND";
    })(CancelBatchQueryCause = DwebgMessage.CancelBatchQueryCause || (DwebgMessage.CancelBatchQueryCause = {}));
    let GetUploadUrlCause;
    (function (GetUploadUrlCause) {
        GetUploadUrlCause[GetUploadUrlCause["GET_UPLOAD_URL_CAUSE_UNKNOWN"] = 0] = "GET_UPLOAD_URL_CAUSE_UNKNOWN";
        GetUploadUrlCause[GetUploadUrlCause["GET_UPLOAD_URL_CAUSE_INVALID_FILE_ID"] = 1] = "GET_UPLOAD_URL_CAUSE_INVALID_FILE_ID";
        GetUploadUrlCause[GetUploadUrlCause["GET_UPLOAD_URL_CAUSE_INVALID_FILE_NAME"] = 2] = "GET_UPLOAD_URL_CAUSE_INVALID_FILE_NAME";
        GetUploadUrlCause[GetUploadUrlCause["GET_UPLOAD_URL_CAUSE_INVALID_FILE_SIZE"] = 3] = "GET_UPLOAD_URL_CAUSE_INVALID_FILE_SIZE";
        GetUploadUrlCause[GetUploadUrlCause["GET_UPLOAD_URL_CAUSE_INSUFFICIENT_PRIVILEGE"] = 4] = "GET_UPLOAD_URL_CAUSE_INSUFFICIENT_PRIVILEGE";
        GetUploadUrlCause[GetUploadUrlCause["GET_UPLOAD_URL_CAUSE_INTERNAL"] = 5] = "GET_UPLOAD_URL_CAUSE_INTERNAL";
        GetUploadUrlCause[GetUploadUrlCause["GET_UPLOAD_URL_CAUSE_INVALID_HEADER"] = 6] = "GET_UPLOAD_URL_CAUSE_INVALID_HEADER";
        GetUploadUrlCause[GetUploadUrlCause["GET_UPLOAD_URL_CAUSE_INVALID_MD5"] = 7] = "GET_UPLOAD_URL_CAUSE_INVALID_MD5";
        GetUploadUrlCause[GetUploadUrlCause["GET_UPLOAD_URL_CAUSE_INVALID_NAME"] = 8] = "GET_UPLOAD_URL_CAUSE_INVALID_NAME";
    })(GetUploadUrlCause = DwebgMessage.GetUploadUrlCause || (DwebgMessage.GetUploadUrlCause = {}));
    let SessionCause;
    (function (SessionCause) {
        SessionCause[SessionCause["SESSION_CAUSE_UNKNOWN"] = 0] = "SESSION_CAUSE_UNKNOWN";
        SessionCause[SessionCause["SESSION_CAUSE_EXPIRED_SESSION"] = 1] = "SESSION_CAUSE_EXPIRED_SESSION";
        SessionCause[SessionCause["SESSION_CAUSE_DB_CONNECTION_FAILED"] = 2] = "SESSION_CAUSE_DB_CONNECTION_FAILED";
        SessionCause[SessionCause["SESSION_CAUSE_MISSING_CREDENTIALS"] = 3] = "SESSION_CAUSE_MISSING_CREDENTIALS";
        SessionCause[SessionCause["SESSION_CAUSE_REQUEST_WITHOUT_AUTH"] = 4] = "SESSION_CAUSE_REQUEST_WITHOUT_AUTH";
        SessionCause[SessionCause["SESSION_CAUSE_INTERNAL"] = 5] = "SESSION_CAUSE_INTERNAL";
        SessionCause[SessionCause["SESSION_CAUSE_EXPIRED_IDENTITY"] = 6] = "SESSION_CAUSE_EXPIRED_IDENTITY";
        SessionCause[SessionCause["SESSION_CAUSE_INVALID_IDENTITY"] = 7] = "SESSION_CAUSE_INVALID_IDENTITY";
        SessionCause[SessionCause["SESSION_CAUSE_REJECTED_IDENTITY"] = 8] = "SESSION_CAUSE_REJECTED_IDENTITY";
        SessionCause[SessionCause["SESSION_CAUSE_REJECTED_CREDENTIALS"] = 9] = "SESSION_CAUSE_REJECTED_CREDENTIALS";
        SessionCause[SessionCause["SESSION_CAUSE_NO_VALID_ROLES"] = 10] = "SESSION_CAUSE_NO_VALID_ROLES";
        SessionCause[SessionCause["SESSION_CAUSE_INVALID_SESSION_TOKEN"] = 11] = "SESSION_CAUSE_INVALID_SESSION_TOKEN";
    })(SessionCause = DwebgMessage.SessionCause || (DwebgMessage.SessionCause = {}));
    let QueryCause;
    (function (QueryCause) {
        QueryCause[QueryCause["QUERY_CAUSE_UNKNOWN"] = 0] = "QUERY_CAUSE_UNKNOWN";
        QueryCause[QueryCause["QUERY_CAUSE_INVALID_QUERY"] = 1] = "QUERY_CAUSE_INVALID_QUERY";
        QueryCause[QueryCause["QUERY_CAUSE_INSUFFICIENT_PRIVILEGE"] = 2] = "QUERY_CAUSE_INSUFFICIENT_PRIVILEGE";
        QueryCause[QueryCause["QUERY_CAUSE_TIMEOUT"] = 3] = "QUERY_CAUSE_TIMEOUT";
        QueryCause[QueryCause["QUERY_CAUSE_TRANSACTION_FAILED"] = 4] = "QUERY_CAUSE_TRANSACTION_FAILED";
    })(QueryCause = DwebgMessage.QueryCause || (DwebgMessage.QueryCause = {}));
    let SubscribeMode;
    (function (SubscribeMode) {
        SubscribeMode[SubscribeMode["SUBSCRIBE_MODE_ONGOING"] = 0] = "SUBSCRIBE_MODE_ONGOING";
        SubscribeMode[SubscribeMode["SUBSCRIBE_MODE_FIRST_POPULATED"] = 1] = "SUBSCRIBE_MODE_FIRST_POPULATED";
    })(SubscribeMode = DwebgMessage.SubscribeMode || (DwebgMessage.SubscribeMode = {}));
    let SubscribeFilter;
    (function (SubscribeFilter) {
        SubscribeFilter[SubscribeFilter["SUBSCRIBE_FILTER_ALL"] = 0] = "SUBSCRIBE_FILTER_ALL";
        SubscribeFilter[SubscribeFilter["SUBSCRIBE_FILTER_UNCHANGED"] = 1] = "SUBSCRIBE_FILTER_UNCHANGED";
        SubscribeFilter[SubscribeFilter["SUBSCRIBE_FILTER_INSERTED"] = 2] = "SUBSCRIBE_FILTER_INSERTED";
        SubscribeFilter[SubscribeFilter["SUBSCRIBE_FILTER_UPDATED"] = 3] = "SUBSCRIBE_FILTER_UPDATED";
        SubscribeFilter[SubscribeFilter["SUBSCRIBE_FILTER_DELETED"] = 4] = "SUBSCRIBE_FILTER_DELETED";
    })(SubscribeFilter = DwebgMessage.SubscribeFilter || (DwebgMessage.SubscribeFilter = {}));
    let SubscribeCause;
    (function (SubscribeCause) {
        SubscribeCause[SubscribeCause["SUBSCRIBE_CAUSE_UNKNOWN"] = 0] = "SUBSCRIBE_CAUSE_UNKNOWN";
        SubscribeCause[SubscribeCause["SUBSCRIBE_CAUSE_LIMIT"] = 1] = "SUBSCRIBE_CAUSE_LIMIT";
        SubscribeCause[SubscribeCause["SUBSCRIBE_CAUSE_INVALID_CHANNEL"] = 2] = "SUBSCRIBE_CAUSE_INVALID_CHANNEL";
        SubscribeCause[SubscribeCause["SUBSCRIBE_CAUSE_ALREADY_EXISTS"] = 3] = "SUBSCRIBE_CAUSE_ALREADY_EXISTS";
        SubscribeCause[SubscribeCause["SUBSCRIBE_CAUSE_NO_ACTIVE_SESSION"] = 4] = "SUBSCRIBE_CAUSE_NO_ACTIVE_SESSION";
        SubscribeCause[SubscribeCause["SUBSCRIBE_CAUSE_TIMEOUT"] = 5] = "SUBSCRIBE_CAUSE_TIMEOUT";
        SubscribeCause[SubscribeCause["SUBSCRIBE_CAUSE_INVALID_QUERY"] = 6] = "SUBSCRIBE_CAUSE_INVALID_QUERY";
        SubscribeCause[SubscribeCause["SUBSCRIBE_CAUSE_INSUFFICIENT_PRIVILEGE"] = 7] = "SUBSCRIBE_CAUSE_INSUFFICIENT_PRIVILEGE";
        SubscribeCause[SubscribeCause["SUBSCRIBE_CAUSE_INVALID_PAYLOAD_FILTER"] = 8] = "SUBSCRIBE_CAUSE_INVALID_PAYLOAD_FILTER";
    })(SubscribeCause = DwebgMessage.SubscribeCause || (DwebgMessage.SubscribeCause = {}));
    let SubscriptionTrigger;
    (function (SubscriptionTrigger) {
        SubscriptionTrigger[SubscriptionTrigger["SUBSCRIPTION_TRIGGER_UNKNOWN"] = 0] = "SUBSCRIPTION_TRIGGER_UNKNOWN";
        SubscriptionTrigger[SubscriptionTrigger["SUBSCRIPTION_TRIGGER_POLL"] = 1] = "SUBSCRIPTION_TRIGGER_POLL";
        SubscriptionTrigger[SubscriptionTrigger["SUBSCRIPTION_TRIGGER_NOTIFY"] = 2] = "SUBSCRIPTION_TRIGGER_NOTIFY";
    })(SubscriptionTrigger = DwebgMessage.SubscriptionTrigger || (DwebgMessage.SubscriptionTrigger = {}));
    let CancelSubscribeCause;
    (function (CancelSubscribeCause) {
        CancelSubscribeCause[CancelSubscribeCause["CANCEL_SUBSCRIBE_CAUSE_UNKNOWN"] = 0] = "CANCEL_SUBSCRIBE_CAUSE_UNKNOWN";
        CancelSubscribeCause[CancelSubscribeCause["CANCEL_SUBSCRIBE_CAUSE_NOT_FOUND"] = 1] = "CANCEL_SUBSCRIBE_CAUSE_NOT_FOUND";
    })(CancelSubscribeCause = DwebgMessage.CancelSubscribeCause || (DwebgMessage.CancelSubscribeCause = {}));
    class AuthRequest extends pb_1.Message {
        constructor(data) {
            super();
            _AuthRequest_one_of_decls.set(this, [[1, 3]]);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _AuthRequest_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("get_session_token" in data && data.get_session_token != undefined) {
                    this.get_session_token = data.get_session_token;
                }
                if ("attach_session_token" in data && data.attach_session_token != undefined) {
                    this.attach_session_token = data.attach_session_token;
                }
            }
        }
        get get_session_token() {
            return pb_1.Message.getWrapperField(this, GetSessionToken, 1);
        }
        set get_session_token(value) {
            pb_1.Message.setOneofWrapperField(this, 1, __classPrivateFieldGet(this, _AuthRequest_one_of_decls, "f")[0], value);
        }
        get has_get_session_token() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get attach_session_token() {
            return pb_1.Message.getWrapperField(this, AttachSessionToken, 3);
        }
        set attach_session_token(value) {
            pb_1.Message.setOneofWrapperField(this, 3, __classPrivateFieldGet(this, _AuthRequest_one_of_decls, "f")[0], value);
        }
        get has_attach_session_token() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get auth_request_type() {
            const cases = {
                0: "none",
                1: "get_session_token",
                3: "attach_session_token"
            };
            return cases[pb_1.Message.computeOneofCase(this, [1, 3])];
        }
        static fromObject(data) {
            const message = new AuthRequest({});
            if (data.get_session_token != null) {
                message.get_session_token = GetSessionToken.fromObject(data.get_session_token);
            }
            if (data.attach_session_token != null) {
                message.attach_session_token = AttachSessionToken.fromObject(data.attach_session_token);
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.get_session_token != null) {
                data.get_session_token = this.get_session_token.toObject();
            }
            if (this.attach_session_token != null) {
                data.attach_session_token = this.attach_session_token.toObject();
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.has_get_session_token)
                writer.writeMessage(1, this.get_session_token, () => this.get_session_token.serialize(writer));
            if (this.has_attach_session_token)
                writer.writeMessage(3, this.attach_session_token, () => this.attach_session_token.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new AuthRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.get_session_token, () => message.get_session_token = GetSessionToken.deserialize(reader));
                        break;
                    case 3:
                        reader.readMessage(message.attach_session_token, () => message.attach_session_token = AttachSessionToken.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return AuthRequest.deserialize(bytes);
        }
    }
    _AuthRequest_one_of_decls = new WeakMap();
    DwebgMessage.AuthRequest = AuthRequest;
    class Request extends pb_1.Message {
        constructor(data) {
            super();
            _Request_one_of_decls.set(this, [[1, 3, 5, 6, 9, 10, 11, 12]]);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _Request_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("get_session_token" in data && data.get_session_token != undefined) {
                    this.get_session_token = data.get_session_token;
                }
                if ("attach_session_token" in data && data.attach_session_token != undefined) {
                    this.attach_session_token = data.attach_session_token;
                }
                if ("batch_query" in data && data.batch_query != undefined) {
                    this.batch_query = data.batch_query;
                }
                if ("subscribe" in data && data.subscribe != undefined) {
                    this.subscribe = data.subscribe;
                }
                if ("cancel_batch_query" in data && data.cancel_batch_query != undefined) {
                    this.cancel_batch_query = data.cancel_batch_query;
                }
                if ("cancel_subscribe" in data && data.cancel_subscribe != undefined) {
                    this.cancel_subscribe = data.cancel_subscribe;
                }
                if ("get_upload_url" in data && data.get_upload_url != undefined) {
                    this.get_upload_url = data.get_upload_url;
                }
                if ("close_session" in data && data.close_session != undefined) {
                    this.close_session = data.close_session;
                }
            }
        }
        get get_session_token() {
            return pb_1.Message.getWrapperField(this, GetSessionToken, 1);
        }
        set get_session_token(value) {
            pb_1.Message.setOneofWrapperField(this, 1, __classPrivateFieldGet(this, _Request_one_of_decls, "f")[0], value);
        }
        get has_get_session_token() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get attach_session_token() {
            return pb_1.Message.getWrapperField(this, AttachSessionToken, 3);
        }
        set attach_session_token(value) {
            pb_1.Message.setOneofWrapperField(this, 3, __classPrivateFieldGet(this, _Request_one_of_decls, "f")[0], value);
        }
        get has_attach_session_token() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get batch_query() {
            return pb_1.Message.getWrapperField(this, BatchQuery, 5);
        }
        set batch_query(value) {
            pb_1.Message.setOneofWrapperField(this, 5, __classPrivateFieldGet(this, _Request_one_of_decls, "f")[0], value);
        }
        get has_batch_query() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get subscribe() {
            return pb_1.Message.getWrapperField(this, Subscribe, 6);
        }
        set subscribe(value) {
            pb_1.Message.setOneofWrapperField(this, 6, __classPrivateFieldGet(this, _Request_one_of_decls, "f")[0], value);
        }
        get has_subscribe() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get cancel_batch_query() {
            return pb_1.Message.getWrapperField(this, CancelBatchQuery, 9);
        }
        set cancel_batch_query(value) {
            pb_1.Message.setOneofWrapperField(this, 9, __classPrivateFieldGet(this, _Request_one_of_decls, "f")[0], value);
        }
        get has_cancel_batch_query() {
            return pb_1.Message.getField(this, 9) != null;
        }
        get cancel_subscribe() {
            return pb_1.Message.getWrapperField(this, CancelSubscribe, 10);
        }
        set cancel_subscribe(value) {
            pb_1.Message.setOneofWrapperField(this, 10, __classPrivateFieldGet(this, _Request_one_of_decls, "f")[0], value);
        }
        get has_cancel_subscribe() {
            return pb_1.Message.getField(this, 10) != null;
        }
        get get_upload_url() {
            return pb_1.Message.getWrapperField(this, GetUploadUrl, 11);
        }
        set get_upload_url(value) {
            pb_1.Message.setOneofWrapperField(this, 11, __classPrivateFieldGet(this, _Request_one_of_decls, "f")[0], value);
        }
        get has_get_upload_url() {
            return pb_1.Message.getField(this, 11) != null;
        }
        get close_session() {
            return pb_1.Message.getWrapperField(this, CloseSession, 12);
        }
        set close_session(value) {
            pb_1.Message.setOneofWrapperField(this, 12, __classPrivateFieldGet(this, _Request_one_of_decls, "f")[0], value);
        }
        get has_close_session() {
            return pb_1.Message.getField(this, 12) != null;
        }
        get request_type() {
            const cases = {
                0: "none",
                1: "get_session_token",
                3: "attach_session_token",
                5: "batch_query",
                6: "subscribe",
                9: "cancel_batch_query",
                10: "cancel_subscribe",
                11: "get_upload_url",
                12: "close_session"
            };
            return cases[pb_1.Message.computeOneofCase(this, [1, 3, 5, 6, 9, 10, 11, 12])];
        }
        static fromObject(data) {
            const message = new Request({});
            if (data.get_session_token != null) {
                message.get_session_token = GetSessionToken.fromObject(data.get_session_token);
            }
            if (data.attach_session_token != null) {
                message.attach_session_token = AttachSessionToken.fromObject(data.attach_session_token);
            }
            if (data.batch_query != null) {
                message.batch_query = BatchQuery.fromObject(data.batch_query);
            }
            if (data.subscribe != null) {
                message.subscribe = Subscribe.fromObject(data.subscribe);
            }
            if (data.cancel_batch_query != null) {
                message.cancel_batch_query = CancelBatchQuery.fromObject(data.cancel_batch_query);
            }
            if (data.cancel_subscribe != null) {
                message.cancel_subscribe = CancelSubscribe.fromObject(data.cancel_subscribe);
            }
            if (data.get_upload_url != null) {
                message.get_upload_url = GetUploadUrl.fromObject(data.get_upload_url);
            }
            if (data.close_session != null) {
                message.close_session = CloseSession.fromObject(data.close_session);
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.get_session_token != null) {
                data.get_session_token = this.get_session_token.toObject();
            }
            if (this.attach_session_token != null) {
                data.attach_session_token = this.attach_session_token.toObject();
            }
            if (this.batch_query != null) {
                data.batch_query = this.batch_query.toObject();
            }
            if (this.subscribe != null) {
                data.subscribe = this.subscribe.toObject();
            }
            if (this.cancel_batch_query != null) {
                data.cancel_batch_query = this.cancel_batch_query.toObject();
            }
            if (this.cancel_subscribe != null) {
                data.cancel_subscribe = this.cancel_subscribe.toObject();
            }
            if (this.get_upload_url != null) {
                data.get_upload_url = this.get_upload_url.toObject();
            }
            if (this.close_session != null) {
                data.close_session = this.close_session.toObject();
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.has_get_session_token)
                writer.writeMessage(1, this.get_session_token, () => this.get_session_token.serialize(writer));
            if (this.has_attach_session_token)
                writer.writeMessage(3, this.attach_session_token, () => this.attach_session_token.serialize(writer));
            if (this.has_batch_query)
                writer.writeMessage(5, this.batch_query, () => this.batch_query.serialize(writer));
            if (this.has_subscribe)
                writer.writeMessage(6, this.subscribe, () => this.subscribe.serialize(writer));
            if (this.has_cancel_batch_query)
                writer.writeMessage(9, this.cancel_batch_query, () => this.cancel_batch_query.serialize(writer));
            if (this.has_cancel_subscribe)
                writer.writeMessage(10, this.cancel_subscribe, () => this.cancel_subscribe.serialize(writer));
            if (this.has_get_upload_url)
                writer.writeMessage(11, this.get_upload_url, () => this.get_upload_url.serialize(writer));
            if (this.has_close_session)
                writer.writeMessage(12, this.close_session, () => this.close_session.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Request();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.get_session_token, () => message.get_session_token = GetSessionToken.deserialize(reader));
                        break;
                    case 3:
                        reader.readMessage(message.attach_session_token, () => message.attach_session_token = AttachSessionToken.deserialize(reader));
                        break;
                    case 5:
                        reader.readMessage(message.batch_query, () => message.batch_query = BatchQuery.deserialize(reader));
                        break;
                    case 6:
                        reader.readMessage(message.subscribe, () => message.subscribe = Subscribe.deserialize(reader));
                        break;
                    case 9:
                        reader.readMessage(message.cancel_batch_query, () => message.cancel_batch_query = CancelBatchQuery.deserialize(reader));
                        break;
                    case 10:
                        reader.readMessage(message.cancel_subscribe, () => message.cancel_subscribe = CancelSubscribe.deserialize(reader));
                        break;
                    case 11:
                        reader.readMessage(message.get_upload_url, () => message.get_upload_url = GetUploadUrl.deserialize(reader));
                        break;
                    case 12:
                        reader.readMessage(message.close_session, () => message.close_session = CloseSession.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return Request.deserialize(bytes);
        }
    }
    _Request_one_of_decls = new WeakMap();
    DwebgMessage.Request = Request;
    class CloseSession extends pb_1.Message {
        constructor(data) {
            super();
            _CloseSession_one_of_decls.set(this, []);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _CloseSession_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("request_id" in data && data.request_id != undefined) {
                    this.request_id = data.request_id;
                }
            }
        }
        get request_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set request_id(value) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data) {
            const message = new CloseSession({});
            if (data.request_id != null) {
                message.request_id = data.request_id;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.request_id != null) {
                data.request_id = this.request_id;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.request_id.length)
                writer.writeString(1, this.request_id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CloseSession();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.request_id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return CloseSession.deserialize(bytes);
        }
    }
    _CloseSession_one_of_decls = new WeakMap();
    DwebgMessage.CloseSession = CloseSession;
    class Response extends pb_1.Message {
        constructor(data) {
            super();
            _Response_one_of_decls.set(this, [[1, 2, 4, 7, 9, 8, 28, 11, 12, 13, 14]]);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _Response_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("session_error" in data && data.session_error != undefined) {
                    this.session_error = data.session_error;
                }
                if ("session_token_status_change" in data && data.session_token_status_change != undefined) {
                    this.session_token_status_change = data.session_token_status_change;
                }
                if ("attach_session_token_response" in data && data.attach_session_token_response != undefined) {
                    this.attach_session_token_response = data.attach_session_token_response;
                }
                if ("query_results" in data && data.query_results != undefined) {
                    this.query_results = data.query_results;
                }
                if ("batch_query_error" in data && data.batch_query_error != undefined) {
                    this.batch_query_error = data.batch_query_error;
                }
                if ("subscribe_results" in data && data.subscribe_results != undefined) {
                    this.subscribe_results = data.subscribe_results;
                }
                if ("subscribe_error" in data && data.subscribe_error != undefined) {
                    this.subscribe_error = data.subscribe_error;
                }
                if ("get_upload_url_response" in data && data.get_upload_url_response != undefined) {
                    this.get_upload_url_response = data.get_upload_url_response;
                }
                if ("get_upload_url_error" in data && data.get_upload_url_error != undefined) {
                    this.get_upload_url_error = data.get_upload_url_error;
                }
                if ("cancel_batch_query_error" in data && data.cancel_batch_query_error != undefined) {
                    this.cancel_batch_query_error = data.cancel_batch_query_error;
                }
                if ("cancel_subscribe_error" in data && data.cancel_subscribe_error != undefined) {
                    this.cancel_subscribe_error = data.cancel_subscribe_error;
                }
            }
        }
        get session_error() {
            return pb_1.Message.getWrapperField(this, SessionError, 1);
        }
        set session_error(value) {
            pb_1.Message.setOneofWrapperField(this, 1, __classPrivateFieldGet(this, _Response_one_of_decls, "f")[0], value);
        }
        get has_session_error() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get session_token_status_change() {
            return pb_1.Message.getWrapperField(this, SessionTokenStatusChange, 2);
        }
        set session_token_status_change(value) {
            pb_1.Message.setOneofWrapperField(this, 2, __classPrivateFieldGet(this, _Response_one_of_decls, "f")[0], value);
        }
        get has_session_token_status_change() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get attach_session_token_response() {
            return pb_1.Message.getWrapperField(this, AttachSessionTokenResponse, 4);
        }
        set attach_session_token_response(value) {
            pb_1.Message.setOneofWrapperField(this, 4, __classPrivateFieldGet(this, _Response_one_of_decls, "f")[0], value);
        }
        get has_attach_session_token_response() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get query_results() {
            return pb_1.Message.getWrapperField(this, QueryResults, 7);
        }
        set query_results(value) {
            pb_1.Message.setOneofWrapperField(this, 7, __classPrivateFieldGet(this, _Response_one_of_decls, "f")[0], value);
        }
        get has_query_results() {
            return pb_1.Message.getField(this, 7) != null;
        }
        get batch_query_error() {
            return pb_1.Message.getWrapperField(this, QueryError, 9);
        }
        set batch_query_error(value) {
            pb_1.Message.setOneofWrapperField(this, 9, __classPrivateFieldGet(this, _Response_one_of_decls, "f")[0], value);
        }
        get has_batch_query_error() {
            return pb_1.Message.getField(this, 9) != null;
        }
        get subscribe_results() {
            return pb_1.Message.getWrapperField(this, SubscribeResults, 8);
        }
        set subscribe_results(value) {
            pb_1.Message.setOneofWrapperField(this, 8, __classPrivateFieldGet(this, _Response_one_of_decls, "f")[0], value);
        }
        get has_subscribe_results() {
            return pb_1.Message.getField(this, 8) != null;
        }
        get subscribe_error() {
            return pb_1.Message.getWrapperField(this, SubscribeError, 28);
        }
        set subscribe_error(value) {
            pb_1.Message.setOneofWrapperField(this, 28, __classPrivateFieldGet(this, _Response_one_of_decls, "f")[0], value);
        }
        get has_subscribe_error() {
            return pb_1.Message.getField(this, 28) != null;
        }
        get get_upload_url_response() {
            return pb_1.Message.getWrapperField(this, GetUploadUrlResponse, 11);
        }
        set get_upload_url_response(value) {
            pb_1.Message.setOneofWrapperField(this, 11, __classPrivateFieldGet(this, _Response_one_of_decls, "f")[0], value);
        }
        get has_get_upload_url_response() {
            return pb_1.Message.getField(this, 11) != null;
        }
        get get_upload_url_error() {
            return pb_1.Message.getWrapperField(this, GetUploadUrlError, 12);
        }
        set get_upload_url_error(value) {
            pb_1.Message.setOneofWrapperField(this, 12, __classPrivateFieldGet(this, _Response_one_of_decls, "f")[0], value);
        }
        get has_get_upload_url_error() {
            return pb_1.Message.getField(this, 12) != null;
        }
        get cancel_batch_query_error() {
            return pb_1.Message.getWrapperField(this, CancelBatchQueryError, 13);
        }
        set cancel_batch_query_error(value) {
            pb_1.Message.setOneofWrapperField(this, 13, __classPrivateFieldGet(this, _Response_one_of_decls, "f")[0], value);
        }
        get has_cancel_batch_query_error() {
            return pb_1.Message.getField(this, 13) != null;
        }
        get cancel_subscribe_error() {
            return pb_1.Message.getWrapperField(this, CancelSubscribeError, 14);
        }
        set cancel_subscribe_error(value) {
            pb_1.Message.setOneofWrapperField(this, 14, __classPrivateFieldGet(this, _Response_one_of_decls, "f")[0], value);
        }
        get has_cancel_subscribe_error() {
            return pb_1.Message.getField(this, 14) != null;
        }
        get response_type() {
            const cases = {
                0: "none",
                1: "session_error",
                2: "session_token_status_change",
                4: "attach_session_token_response",
                7: "query_results",
                9: "batch_query_error",
                8: "subscribe_results",
                28: "subscribe_error",
                11: "get_upload_url_response",
                12: "get_upload_url_error",
                13: "cancel_batch_query_error",
                14: "cancel_subscribe_error"
            };
            return cases[pb_1.Message.computeOneofCase(this, [1, 2, 4, 7, 9, 8, 28, 11, 12, 13, 14])];
        }
        static fromObject(data) {
            const message = new Response({});
            if (data.session_error != null) {
                message.session_error = SessionError.fromObject(data.session_error);
            }
            if (data.session_token_status_change != null) {
                message.session_token_status_change = SessionTokenStatusChange.fromObject(data.session_token_status_change);
            }
            if (data.attach_session_token_response != null) {
                message.attach_session_token_response = AttachSessionTokenResponse.fromObject(data.attach_session_token_response);
            }
            if (data.query_results != null) {
                message.query_results = QueryResults.fromObject(data.query_results);
            }
            if (data.batch_query_error != null) {
                message.batch_query_error = QueryError.fromObject(data.batch_query_error);
            }
            if (data.subscribe_results != null) {
                message.subscribe_results = SubscribeResults.fromObject(data.subscribe_results);
            }
            if (data.subscribe_error != null) {
                message.subscribe_error = SubscribeError.fromObject(data.subscribe_error);
            }
            if (data.get_upload_url_response != null) {
                message.get_upload_url_response = GetUploadUrlResponse.fromObject(data.get_upload_url_response);
            }
            if (data.get_upload_url_error != null) {
                message.get_upload_url_error = GetUploadUrlError.fromObject(data.get_upload_url_error);
            }
            if (data.cancel_batch_query_error != null) {
                message.cancel_batch_query_error = CancelBatchQueryError.fromObject(data.cancel_batch_query_error);
            }
            if (data.cancel_subscribe_error != null) {
                message.cancel_subscribe_error = CancelSubscribeError.fromObject(data.cancel_subscribe_error);
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.session_error != null) {
                data.session_error = this.session_error.toObject();
            }
            if (this.session_token_status_change != null) {
                data.session_token_status_change = this.session_token_status_change.toObject();
            }
            if (this.attach_session_token_response != null) {
                data.attach_session_token_response = this.attach_session_token_response.toObject();
            }
            if (this.query_results != null) {
                data.query_results = this.query_results.toObject();
            }
            if (this.batch_query_error != null) {
                data.batch_query_error = this.batch_query_error.toObject();
            }
            if (this.subscribe_results != null) {
                data.subscribe_results = this.subscribe_results.toObject();
            }
            if (this.subscribe_error != null) {
                data.subscribe_error = this.subscribe_error.toObject();
            }
            if (this.get_upload_url_response != null) {
                data.get_upload_url_response = this.get_upload_url_response.toObject();
            }
            if (this.get_upload_url_error != null) {
                data.get_upload_url_error = this.get_upload_url_error.toObject();
            }
            if (this.cancel_batch_query_error != null) {
                data.cancel_batch_query_error = this.cancel_batch_query_error.toObject();
            }
            if (this.cancel_subscribe_error != null) {
                data.cancel_subscribe_error = this.cancel_subscribe_error.toObject();
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.has_session_error)
                writer.writeMessage(1, this.session_error, () => this.session_error.serialize(writer));
            if (this.has_session_token_status_change)
                writer.writeMessage(2, this.session_token_status_change, () => this.session_token_status_change.serialize(writer));
            if (this.has_attach_session_token_response)
                writer.writeMessage(4, this.attach_session_token_response, () => this.attach_session_token_response.serialize(writer));
            if (this.has_query_results)
                writer.writeMessage(7, this.query_results, () => this.query_results.serialize(writer));
            if (this.has_batch_query_error)
                writer.writeMessage(9, this.batch_query_error, () => this.batch_query_error.serialize(writer));
            if (this.has_subscribe_results)
                writer.writeMessage(8, this.subscribe_results, () => this.subscribe_results.serialize(writer));
            if (this.has_subscribe_error)
                writer.writeMessage(28, this.subscribe_error, () => this.subscribe_error.serialize(writer));
            if (this.has_get_upload_url_response)
                writer.writeMessage(11, this.get_upload_url_response, () => this.get_upload_url_response.serialize(writer));
            if (this.has_get_upload_url_error)
                writer.writeMessage(12, this.get_upload_url_error, () => this.get_upload_url_error.serialize(writer));
            if (this.has_cancel_batch_query_error)
                writer.writeMessage(13, this.cancel_batch_query_error, () => this.cancel_batch_query_error.serialize(writer));
            if (this.has_cancel_subscribe_error)
                writer.writeMessage(14, this.cancel_subscribe_error, () => this.cancel_subscribe_error.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Response();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.session_error, () => message.session_error = SessionError.deserialize(reader));
                        break;
                    case 2:
                        reader.readMessage(message.session_token_status_change, () => message.session_token_status_change = SessionTokenStatusChange.deserialize(reader));
                        break;
                    case 4:
                        reader.readMessage(message.attach_session_token_response, () => message.attach_session_token_response = AttachSessionTokenResponse.deserialize(reader));
                        break;
                    case 7:
                        reader.readMessage(message.query_results, () => message.query_results = QueryResults.deserialize(reader));
                        break;
                    case 9:
                        reader.readMessage(message.batch_query_error, () => message.batch_query_error = QueryError.deserialize(reader));
                        break;
                    case 8:
                        reader.readMessage(message.subscribe_results, () => message.subscribe_results = SubscribeResults.deserialize(reader));
                        break;
                    case 28:
                        reader.readMessage(message.subscribe_error, () => message.subscribe_error = SubscribeError.deserialize(reader));
                        break;
                    case 11:
                        reader.readMessage(message.get_upload_url_response, () => message.get_upload_url_response = GetUploadUrlResponse.deserialize(reader));
                        break;
                    case 12:
                        reader.readMessage(message.get_upload_url_error, () => message.get_upload_url_error = GetUploadUrlError.deserialize(reader));
                        break;
                    case 13:
                        reader.readMessage(message.cancel_batch_query_error, () => message.cancel_batch_query_error = CancelBatchQueryError.deserialize(reader));
                        break;
                    case 14:
                        reader.readMessage(message.cancel_subscribe_error, () => message.cancel_subscribe_error = CancelSubscribeError.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return Response.deserialize(bytes);
        }
    }
    _Response_one_of_decls = new WeakMap();
    DwebgMessage.Response = Response;
    class CancelBatchQueryError extends pb_1.Message {
        constructor(data) {
            super();
            _CancelBatchQueryError_one_of_decls.set(this, []);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [3], __classPrivateFieldGet(this, _CancelBatchQueryError_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("request_id" in data && data.request_id != undefined) {
                    this.request_id = data.request_id;
                }
                if ("batch_id" in data && data.batch_id != undefined) {
                    this.batch_id = data.batch_id;
                }
                if ("statement_ids" in data && data.statement_ids != undefined) {
                    this.statement_ids = data.statement_ids;
                }
                if ("error" in data && data.error != undefined) {
                    this.error = data.error;
                }
                if ("cause" in data && data.cause != undefined) {
                    this.cause = data.cause;
                }
            }
        }
        get request_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set request_id(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get batch_id() {
            return pb_1.Message.getFieldWithDefault(this, 2, "");
        }
        set batch_id(value) {
            pb_1.Message.setField(this, 2, value);
        }
        get statement_ids() {
            return pb_1.Message.getFieldWithDefault(this, 3, []);
        }
        set statement_ids(value) {
            pb_1.Message.setField(this, 3, value);
        }
        get error() {
            return pb_1.Message.getFieldWithDefault(this, 4, "");
        }
        set error(value) {
            pb_1.Message.setField(this, 4, value);
        }
        get cause() {
            return pb_1.Message.getFieldWithDefault(this, 5, CancelBatchQueryCause.CANCEL_BATCH_QUERY_CAUSE_UNKNOWN);
        }
        set cause(value) {
            pb_1.Message.setField(this, 5, value);
        }
        static fromObject(data) {
            const message = new CancelBatchQueryError({});
            if (data.request_id != null) {
                message.request_id = data.request_id;
            }
            if (data.batch_id != null) {
                message.batch_id = data.batch_id;
            }
            if (data.statement_ids != null) {
                message.statement_ids = data.statement_ids;
            }
            if (data.error != null) {
                message.error = data.error;
            }
            if (data.cause != null) {
                message.cause = data.cause;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.request_id != null) {
                data.request_id = this.request_id;
            }
            if (this.batch_id != null) {
                data.batch_id = this.batch_id;
            }
            if (this.statement_ids != null) {
                data.statement_ids = this.statement_ids;
            }
            if (this.error != null) {
                data.error = this.error;
            }
            if (this.cause != null) {
                data.cause = this.cause;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.request_id.length)
                writer.writeString(1, this.request_id);
            if (this.batch_id.length)
                writer.writeString(2, this.batch_id);
            if (this.statement_ids.length)
                writer.writeRepeatedString(3, this.statement_ids);
            if (this.error.length)
                writer.writeString(4, this.error);
            if (this.cause != CancelBatchQueryCause.CANCEL_BATCH_QUERY_CAUSE_UNKNOWN)
                writer.writeEnum(5, this.cause);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CancelBatchQueryError();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.request_id = reader.readString();
                        break;
                    case 2:
                        message.batch_id = reader.readString();
                        break;
                    case 3:
                        pb_1.Message.addToRepeatedField(message, 3, reader.readString());
                        break;
                    case 4:
                        message.error = reader.readString();
                        break;
                    case 5:
                        message.cause = reader.readEnum();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return CancelBatchQueryError.deserialize(bytes);
        }
    }
    _CancelBatchQueryError_one_of_decls = new WeakMap();
    DwebgMessage.CancelBatchQueryError = CancelBatchQueryError;
    class GetUploadUrl extends pb_1.Message {
        constructor(data) {
            super();
            _GetUploadUrl_one_of_decls.set(this, [[4]]);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _GetUploadUrl_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("request_id" in data && data.request_id != undefined) {
                    this.request_id = data.request_id;
                }
                if ("file_name" in data && data.file_name != undefined) {
                    this.file_name = data.file_name;
                }
                if ("file_size" in data && data.file_size != undefined) {
                    this.file_size = data.file_size;
                }
                if ("md5" in data && data.md5 != undefined) {
                    this.md5 = data.md5;
                }
            }
        }
        get request_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set request_id(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get file_name() {
            return pb_1.Message.getFieldWithDefault(this, 2, "");
        }
        set file_name(value) {
            pb_1.Message.setField(this, 2, value);
        }
        get file_size() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0);
        }
        set file_size(value) {
            pb_1.Message.setField(this, 3, value);
        }
        get md5() {
            return pb_1.Message.getFieldWithDefault(this, 4, "");
        }
        set md5(value) {
            pb_1.Message.setOneofField(this, 4, __classPrivateFieldGet(this, _GetUploadUrl_one_of_decls, "f")[0], value);
        }
        get has_md5() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get _md5() {
            const cases = {
                0: "none",
                4: "md5"
            };
            return cases[pb_1.Message.computeOneofCase(this, [4])];
        }
        static fromObject(data) {
            const message = new GetUploadUrl({});
            if (data.request_id != null) {
                message.request_id = data.request_id;
            }
            if (data.file_name != null) {
                message.file_name = data.file_name;
            }
            if (data.file_size != null) {
                message.file_size = data.file_size;
            }
            if (data.md5 != null) {
                message.md5 = data.md5;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.request_id != null) {
                data.request_id = this.request_id;
            }
            if (this.file_name != null) {
                data.file_name = this.file_name;
            }
            if (this.file_size != null) {
                data.file_size = this.file_size;
            }
            if (this.md5 != null) {
                data.md5 = this.md5;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.request_id.length)
                writer.writeString(1, this.request_id);
            if (this.file_name.length)
                writer.writeString(2, this.file_name);
            if (this.file_size != 0)
                writer.writeUint64(3, this.file_size);
            if (this.has_md5)
                writer.writeString(4, this.md5);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetUploadUrl();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.request_id = reader.readString();
                        break;
                    case 2:
                        message.file_name = reader.readString();
                        break;
                    case 3:
                        message.file_size = reader.readUint64();
                        break;
                    case 4:
                        message.md5 = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return GetUploadUrl.deserialize(bytes);
        }
    }
    _GetUploadUrl_one_of_decls = new WeakMap();
    DwebgMessage.GetUploadUrl = GetUploadUrl;
    class GetUploadUrlResponse extends pb_1.Message {
        constructor(data) {
            super();
            _GetUploadUrlResponse_one_of_decls.set(this, []);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _GetUploadUrlResponse_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("request_id" in data && data.request_id != undefined) {
                    this.request_id = data.request_id;
                }
                if ("upload_url" in data && data.upload_url != undefined) {
                    this.upload_url = data.upload_url;
                }
                if ("upload_table_id" in data && data.upload_table_id != undefined) {
                    this.upload_table_id = data.upload_table_id;
                }
            }
        }
        get request_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set request_id(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get upload_url() {
            return pb_1.Message.getFieldWithDefault(this, 2, "");
        }
        set upload_url(value) {
            pb_1.Message.setField(this, 2, value);
        }
        get upload_table_id() {
            return pb_1.Message.getWrapperField(this, IdValue, 3);
        }
        set upload_table_id(value) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get has_upload_table_id() {
            return pb_1.Message.getField(this, 3) != null;
        }
        static fromObject(data) {
            const message = new GetUploadUrlResponse({});
            if (data.request_id != null) {
                message.request_id = data.request_id;
            }
            if (data.upload_url != null) {
                message.upload_url = data.upload_url;
            }
            if (data.upload_table_id != null) {
                message.upload_table_id = IdValue.fromObject(data.upload_table_id);
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.request_id != null) {
                data.request_id = this.request_id;
            }
            if (this.upload_url != null) {
                data.upload_url = this.upload_url;
            }
            if (this.upload_table_id != null) {
                data.upload_table_id = this.upload_table_id.toObject();
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.request_id.length)
                writer.writeString(1, this.request_id);
            if (this.upload_url.length)
                writer.writeString(2, this.upload_url);
            if (this.has_upload_table_id)
                writer.writeMessage(3, this.upload_table_id, () => this.upload_table_id.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetUploadUrlResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.request_id = reader.readString();
                        break;
                    case 2:
                        message.upload_url = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message.upload_table_id, () => message.upload_table_id = IdValue.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return GetUploadUrlResponse.deserialize(bytes);
        }
    }
    _GetUploadUrlResponse_one_of_decls = new WeakMap();
    DwebgMessage.GetUploadUrlResponse = GetUploadUrlResponse;
    class GetUploadUrlError extends pb_1.Message {
        constructor(data) {
            super();
            _GetUploadUrlError_one_of_decls.set(this, []);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _GetUploadUrlError_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("request_id" in data && data.request_id != undefined) {
                    this.request_id = data.request_id;
                }
                if ("error" in data && data.error != undefined) {
                    this.error = data.error;
                }
                if ("cause" in data && data.cause != undefined) {
                    this.cause = data.cause;
                }
            }
        }
        get request_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set request_id(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get error() {
            return pb_1.Message.getFieldWithDefault(this, 2, "");
        }
        set error(value) {
            pb_1.Message.setField(this, 2, value);
        }
        get cause() {
            return pb_1.Message.getFieldWithDefault(this, 3, GetUploadUrlCause.GET_UPLOAD_URL_CAUSE_UNKNOWN);
        }
        set cause(value) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data) {
            const message = new GetUploadUrlError({});
            if (data.request_id != null) {
                message.request_id = data.request_id;
            }
            if (data.error != null) {
                message.error = data.error;
            }
            if (data.cause != null) {
                message.cause = data.cause;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.request_id != null) {
                data.request_id = this.request_id;
            }
            if (this.error != null) {
                data.error = this.error;
            }
            if (this.cause != null) {
                data.cause = this.cause;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.request_id.length)
                writer.writeString(1, this.request_id);
            if (this.error.length)
                writer.writeString(2, this.error);
            if (this.cause != GetUploadUrlCause.GET_UPLOAD_URL_CAUSE_UNKNOWN)
                writer.writeEnum(3, this.cause);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetUploadUrlError();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.request_id = reader.readString();
                        break;
                    case 2:
                        message.error = reader.readString();
                        break;
                    case 3:
                        message.cause = reader.readEnum();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return GetUploadUrlError.deserialize(bytes);
        }
    }
    _GetUploadUrlError_one_of_decls = new WeakMap();
    DwebgMessage.GetUploadUrlError = GetUploadUrlError;
    class GetSessionToken extends pb_1.Message {
        constructor(data) {
            super();
            _GetSessionToken_one_of_decls.set(this, [[2, 3]]);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _GetSessionToken_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("request_id" in data && data.request_id != undefined) {
                    this.request_id = data.request_id;
                }
                if ("identity" in data && data.identity != undefined) {
                    this.identity = data.identity;
                }
                if ("credentials" in data && data.credentials != undefined) {
                    this.credentials = data.credentials;
                }
            }
        }
        get request_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set request_id(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get identity() {
            return pb_1.Message.getFieldWithDefault(this, 2, "");
        }
        set identity(value) {
            pb_1.Message.setOneofField(this, 2, __classPrivateFieldGet(this, _GetSessionToken_one_of_decls, "f")[0], value);
        }
        get has_identity() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get credentials() {
            return pb_1.Message.getWrapperField(this, LoginCredentials, 3);
        }
        set credentials(value) {
            pb_1.Message.setOneofWrapperField(this, 3, __classPrivateFieldGet(this, _GetSessionToken_one_of_decls, "f")[0], value);
        }
        get has_credentials() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get get_session_token_type() {
            const cases = {
                0: "none",
                2: "identity",
                3: "credentials"
            };
            return cases[pb_1.Message.computeOneofCase(this, [2, 3])];
        }
        static fromObject(data) {
            const message = new GetSessionToken({});
            if (data.request_id != null) {
                message.request_id = data.request_id;
            }
            if (data.identity != null) {
                message.identity = data.identity;
            }
            if (data.credentials != null) {
                message.credentials = LoginCredentials.fromObject(data.credentials);
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.request_id != null) {
                data.request_id = this.request_id;
            }
            if (this.identity != null) {
                data.identity = this.identity;
            }
            if (this.credentials != null) {
                data.credentials = this.credentials.toObject();
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.request_id.length)
                writer.writeString(1, this.request_id);
            if (this.has_identity)
                writer.writeString(2, this.identity);
            if (this.has_credentials)
                writer.writeMessage(3, this.credentials, () => this.credentials.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetSessionToken();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.request_id = reader.readString();
                        break;
                    case 2:
                        message.identity = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message.credentials, () => message.credentials = LoginCredentials.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return GetSessionToken.deserialize(bytes);
        }
    }
    _GetSessionToken_one_of_decls = new WeakMap();
    DwebgMessage.GetSessionToken = GetSessionToken;
    class LoginCredentials extends pb_1.Message {
        constructor(data) {
            super();
            _LoginCredentials_one_of_decls.set(this, []);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _LoginCredentials_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("username" in data && data.username != undefined) {
                    this.username = data.username;
                }
                if ("password" in data && data.password != undefined) {
                    this.password = data.password;
                }
            }
        }
        get username() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set username(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get password() {
            return pb_1.Message.getFieldWithDefault(this, 2, "");
        }
        set password(value) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data) {
            const message = new LoginCredentials({});
            if (data.username != null) {
                message.username = data.username;
            }
            if (data.password != null) {
                message.password = data.password;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.username != null) {
                data.username = this.username;
            }
            if (this.password != null) {
                data.password = this.password;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.username.length)
                writer.writeString(1, this.username);
            if (this.password.length)
                writer.writeString(2, this.password);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new LoginCredentials();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.username = reader.readString();
                        break;
                    case 2:
                        message.password = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return LoginCredentials.deserialize(bytes);
        }
    }
    _LoginCredentials_one_of_decls = new WeakMap();
    DwebgMessage.LoginCredentials = LoginCredentials;
    class SessionTokenStatusChange extends pb_1.Message {
        constructor(data) {
            super();
            _SessionTokenStatusChange_one_of_decls.set(this, [[2], [3]]);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _SessionTokenStatusChange_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("token" in data && data.token != undefined) {
                    this.token = data.token;
                }
                if ("request_id" in data && data.request_id != undefined) {
                    this.request_id = data.request_id;
                }
                if ("expires_in_ms" in data && data.expires_in_ms != undefined) {
                    this.expires_in_ms = data.expires_in_ms;
                }
            }
        }
        get token() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set token(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get request_id() {
            return pb_1.Message.getFieldWithDefault(this, 2, "");
        }
        set request_id(value) {
            pb_1.Message.setOneofField(this, 2, __classPrivateFieldGet(this, _SessionTokenStatusChange_one_of_decls, "f")[0], value);
        }
        get has_request_id() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get expires_in_ms() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0);
        }
        set expires_in_ms(value) {
            pb_1.Message.setOneofField(this, 3, __classPrivateFieldGet(this, _SessionTokenStatusChange_one_of_decls, "f")[1], value);
        }
        get has_expires_in_ms() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get _request_id() {
            const cases = {
                0: "none",
                2: "request_id"
            };
            return cases[pb_1.Message.computeOneofCase(this, [2])];
        }
        get _expires_in_ms() {
            const cases = {
                0: "none",
                3: "expires_in_ms"
            };
            return cases[pb_1.Message.computeOneofCase(this, [3])];
        }
        static fromObject(data) {
            const message = new SessionTokenStatusChange({});
            if (data.token != null) {
                message.token = data.token;
            }
            if (data.request_id != null) {
                message.request_id = data.request_id;
            }
            if (data.expires_in_ms != null) {
                message.expires_in_ms = data.expires_in_ms;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.token != null) {
                data.token = this.token;
            }
            if (this.request_id != null) {
                data.request_id = this.request_id;
            }
            if (this.expires_in_ms != null) {
                data.expires_in_ms = this.expires_in_ms;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.token.length)
                writer.writeString(1, this.token);
            if (this.has_request_id)
                writer.writeString(2, this.request_id);
            if (this.has_expires_in_ms)
                writer.writeInt64(3, this.expires_in_ms);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SessionTokenStatusChange();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.token = reader.readString();
                        break;
                    case 2:
                        message.request_id = reader.readString();
                        break;
                    case 3:
                        message.expires_in_ms = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return SessionTokenStatusChange.deserialize(bytes);
        }
    }
    _SessionTokenStatusChange_one_of_decls = new WeakMap();
    DwebgMessage.SessionTokenStatusChange = SessionTokenStatusChange;
    class SessionError extends pb_1.Message {
        constructor(data) {
            super();
            _SessionError_one_of_decls.set(this, []);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _SessionError_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("error" in data && data.error != undefined) {
                    this.error = data.error;
                }
                if ("cause" in data && data.cause != undefined) {
                    this.cause = data.cause;
                }
            }
        }
        get error() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set error(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get cause() {
            return pb_1.Message.getFieldWithDefault(this, 2, SessionCause.SESSION_CAUSE_UNKNOWN);
        }
        set cause(value) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data) {
            const message = new SessionError({});
            if (data.error != null) {
                message.error = data.error;
            }
            if (data.cause != null) {
                message.cause = data.cause;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.error != null) {
                data.error = this.error;
            }
            if (this.cause != null) {
                data.cause = this.cause;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.error.length)
                writer.writeString(1, this.error);
            if (this.cause != SessionCause.SESSION_CAUSE_UNKNOWN)
                writer.writeEnum(2, this.cause);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SessionError();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.error = reader.readString();
                        break;
                    case 2:
                        message.cause = reader.readEnum();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return SessionError.deserialize(bytes);
        }
    }
    _SessionError_one_of_decls = new WeakMap();
    DwebgMessage.SessionError = SessionError;
    class AttachSessionToken extends pb_1.Message {
        constructor(data) {
            super();
            _AttachSessionToken_one_of_decls.set(this, []);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _AttachSessionToken_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("request_id" in data && data.request_id != undefined) {
                    this.request_id = data.request_id;
                }
                if ("token" in data && data.token != undefined) {
                    this.token = data.token;
                }
            }
        }
        get request_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set request_id(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get token() {
            return pb_1.Message.getFieldWithDefault(this, 2, "");
        }
        set token(value) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data) {
            const message = new AttachSessionToken({});
            if (data.request_id != null) {
                message.request_id = data.request_id;
            }
            if (data.token != null) {
                message.token = data.token;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.request_id != null) {
                data.request_id = this.request_id;
            }
            if (this.token != null) {
                data.token = this.token;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.request_id.length)
                writer.writeString(1, this.request_id);
            if (this.token.length)
                writer.writeString(2, this.token);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new AttachSessionToken();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.request_id = reader.readString();
                        break;
                    case 2:
                        message.token = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return AttachSessionToken.deserialize(bytes);
        }
    }
    _AttachSessionToken_one_of_decls = new WeakMap();
    DwebgMessage.AttachSessionToken = AttachSessionToken;
    class AttachSessionTokenResponse extends pb_1.Message {
        constructor(data) {
            super();
            _AttachSessionTokenResponse_one_of_decls.set(this, [[2], [3]]);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _AttachSessionTokenResponse_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("request_id" in data && data.request_id != undefined) {
                    this.request_id = data.request_id;
                }
                if ("expires_in_ms" in data && data.expires_in_ms != undefined) {
                    this.expires_in_ms = data.expires_in_ms;
                }
            }
        }
        get request_id() {
            return pb_1.Message.getFieldWithDefault(this, 2, "");
        }
        set request_id(value) {
            pb_1.Message.setOneofField(this, 2, __classPrivateFieldGet(this, _AttachSessionTokenResponse_one_of_decls, "f")[0], value);
        }
        get has_request_id() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get expires_in_ms() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0);
        }
        set expires_in_ms(value) {
            pb_1.Message.setOneofField(this, 3, __classPrivateFieldGet(this, _AttachSessionTokenResponse_one_of_decls, "f")[1], value);
        }
        get has_expires_in_ms() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get _request_id() {
            const cases = {
                0: "none",
                2: "request_id"
            };
            return cases[pb_1.Message.computeOneofCase(this, [2])];
        }
        get _expires_in_ms() {
            const cases = {
                0: "none",
                3: "expires_in_ms"
            };
            return cases[pb_1.Message.computeOneofCase(this, [3])];
        }
        static fromObject(data) {
            const message = new AttachSessionTokenResponse({});
            if (data.request_id != null) {
                message.request_id = data.request_id;
            }
            if (data.expires_in_ms != null) {
                message.expires_in_ms = data.expires_in_ms;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.request_id != null) {
                data.request_id = this.request_id;
            }
            if (this.expires_in_ms != null) {
                data.expires_in_ms = this.expires_in_ms;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.has_request_id)
                writer.writeString(2, this.request_id);
            if (this.has_expires_in_ms)
                writer.writeInt64(3, this.expires_in_ms);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new AttachSessionTokenResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 2:
                        message.request_id = reader.readString();
                        break;
                    case 3:
                        message.expires_in_ms = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return AttachSessionTokenResponse.deserialize(bytes);
        }
    }
    _AttachSessionTokenResponse_one_of_decls = new WeakMap();
    DwebgMessage.AttachSessionTokenResponse = AttachSessionTokenResponse;
    class BatchQuery extends pb_1.Message {
        constructor(data) {
            super();
            _BatchQuery_one_of_decls.set(this, []);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2], __classPrivateFieldGet(this, _BatchQuery_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("batch_id" in data && data.batch_id != undefined) {
                    this.batch_id = data.batch_id;
                }
                if ("queries" in data && data.queries != undefined) {
                    this.queries = data.queries;
                }
                if ("single_transaction" in data && data.single_transaction != undefined) {
                    this.single_transaction = data.single_transaction;
                }
            }
        }
        get batch_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set batch_id(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get queries() {
            return pb_1.Message.getRepeatedWrapperField(this, Query, 2);
        }
        set queries(value) {
            pb_1.Message.setRepeatedWrapperField(this, 2, value);
        }
        get single_transaction() {
            return pb_1.Message.getFieldWithDefault(this, 3, false);
        }
        set single_transaction(value) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data) {
            const message = new BatchQuery({});
            if (data.batch_id != null) {
                message.batch_id = data.batch_id;
            }
            if (data.queries != null) {
                message.queries = data.queries.map(item => Query.fromObject(item));
            }
            if (data.single_transaction != null) {
                message.single_transaction = data.single_transaction;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.batch_id != null) {
                data.batch_id = this.batch_id;
            }
            if (this.queries != null) {
                data.queries = this.queries.map((item) => item.toObject());
            }
            if (this.single_transaction != null) {
                data.single_transaction = this.single_transaction;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.batch_id.length)
                writer.writeString(1, this.batch_id);
            if (this.queries.length)
                writer.writeRepeatedMessage(2, this.queries, (item) => item.serialize(writer));
            if (this.single_transaction != false)
                writer.writeBool(3, this.single_transaction);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new BatchQuery();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.batch_id = reader.readString();
                        break;
                    case 2:
                        reader.readMessage(message.queries, () => pb_1.Message.addToRepeatedWrapperField(message, 2, Query.deserialize(reader), Query));
                        break;
                    case 3:
                        message.single_transaction = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return BatchQuery.deserialize(bytes);
        }
    }
    _BatchQuery_one_of_decls = new WeakMap();
    DwebgMessage.BatchQuery = BatchQuery;
    class Query extends pb_1.Message {
        constructor(data) {
            super();
            _Query_one_of_decls.set(this, [[4], [5], [6]]);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [3], __classPrivateFieldGet(this, _Query_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("statement_id" in data && data.statement_id != undefined) {
                    this.statement_id = data.statement_id;
                }
                if ("statement" in data && data.statement != undefined) {
                    this.statement = data.statement;
                }
                if ("parameters" in data && data.parameters != undefined) {
                    this.parameters = data.parameters;
                }
                if ("server" in data && data.server != undefined) {
                    this.server = data.server;
                }
                if ("database" in data && data.database != undefined) {
                    this.database = data.database;
                }
                if ("schema" in data && data.schema != undefined) {
                    this.schema = data.schema;
                }
                if ("skip_column_names" in data && data.skip_column_names != undefined) {
                    this.skip_column_names = data.skip_column_names;
                }
            }
        }
        get statement_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set statement_id(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get statement() {
            return pb_1.Message.getFieldWithDefault(this, 2, "");
        }
        set statement(value) {
            pb_1.Message.setField(this, 2, value);
        }
        get parameters() {
            return pb_1.Message.getRepeatedWrapperField(this, Value, 3);
        }
        set parameters(value) {
            pb_1.Message.setRepeatedWrapperField(this, 3, value);
        }
        get server() {
            return pb_1.Message.getFieldWithDefault(this, 4, "");
        }
        set server(value) {
            pb_1.Message.setOneofField(this, 4, __classPrivateFieldGet(this, _Query_one_of_decls, "f")[0], value);
        }
        get has_server() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get database() {
            return pb_1.Message.getFieldWithDefault(this, 5, "");
        }
        set database(value) {
            pb_1.Message.setOneofField(this, 5, __classPrivateFieldGet(this, _Query_one_of_decls, "f")[1], value);
        }
        get has_database() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get schema() {
            return pb_1.Message.getFieldWithDefault(this, 6, "");
        }
        set schema(value) {
            pb_1.Message.setOneofField(this, 6, __classPrivateFieldGet(this, _Query_one_of_decls, "f")[2], value);
        }
        get has_schema() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get skip_column_names() {
            return pb_1.Message.getFieldWithDefault(this, 9, false);
        }
        set skip_column_names(value) {
            pb_1.Message.setField(this, 9, value);
        }
        get _server() {
            const cases = {
                0: "none",
                4: "server"
            };
            return cases[pb_1.Message.computeOneofCase(this, [4])];
        }
        get _database() {
            const cases = {
                0: "none",
                5: "database"
            };
            return cases[pb_1.Message.computeOneofCase(this, [5])];
        }
        get _schema() {
            const cases = {
                0: "none",
                6: "schema"
            };
            return cases[pb_1.Message.computeOneofCase(this, [6])];
        }
        static fromObject(data) {
            const message = new Query({});
            if (data.statement_id != null) {
                message.statement_id = data.statement_id;
            }
            if (data.statement != null) {
                message.statement = data.statement;
            }
            if (data.parameters != null) {
                message.parameters = data.parameters.map(item => Value.fromObject(item));
            }
            if (data.server != null) {
                message.server = data.server;
            }
            if (data.database != null) {
                message.database = data.database;
            }
            if (data.schema != null) {
                message.schema = data.schema;
            }
            if (data.skip_column_names != null) {
                message.skip_column_names = data.skip_column_names;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.statement_id != null) {
                data.statement_id = this.statement_id;
            }
            if (this.statement != null) {
                data.statement = this.statement;
            }
            if (this.parameters != null) {
                data.parameters = this.parameters.map((item) => item.toObject());
            }
            if (this.server != null) {
                data.server = this.server;
            }
            if (this.database != null) {
                data.database = this.database;
            }
            if (this.schema != null) {
                data.schema = this.schema;
            }
            if (this.skip_column_names != null) {
                data.skip_column_names = this.skip_column_names;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.statement_id.length)
                writer.writeString(1, this.statement_id);
            if (this.statement.length)
                writer.writeString(2, this.statement);
            if (this.parameters.length)
                writer.writeRepeatedMessage(3, this.parameters, (item) => item.serialize(writer));
            if (this.has_server)
                writer.writeString(4, this.server);
            if (this.has_database)
                writer.writeString(5, this.database);
            if (this.has_schema)
                writer.writeString(6, this.schema);
            if (this.skip_column_names != false)
                writer.writeBool(9, this.skip_column_names);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Query();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.statement_id = reader.readString();
                        break;
                    case 2:
                        message.statement = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message.parameters, () => pb_1.Message.addToRepeatedWrapperField(message, 3, Value.deserialize(reader), Value));
                        break;
                    case 4:
                        message.server = reader.readString();
                        break;
                    case 5:
                        message.database = reader.readString();
                        break;
                    case 6:
                        message.schema = reader.readString();
                        break;
                    case 9:
                        message.skip_column_names = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return Query.deserialize(bytes);
        }
    }
    _Query_one_of_decls = new WeakMap();
    DwebgMessage.Query = Query;
    class Records extends pb_1.Message {
        constructor(data) {
            super();
            _Records_one_of_decls.set(this, []);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], __classPrivateFieldGet(this, _Records_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("rows" in data && data.rows != undefined) {
                    this.rows = data.rows;
                }
            }
        }
        get rows() {
            return pb_1.Message.getRepeatedWrapperField(this, List, 1);
        }
        set rows(value) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        static fromObject(data) {
            const message = new Records({});
            if (data.rows != null) {
                message.rows = data.rows.map(item => List.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.rows != null) {
                data.rows = this.rows.map((item) => item.toObject());
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.rows.length)
                writer.writeRepeatedMessage(1, this.rows, (item) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Records();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.rows, () => pb_1.Message.addToRepeatedWrapperField(message, 1, List.deserialize(reader), List));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return Records.deserialize(bytes);
        }
    }
    _Records_one_of_decls = new WeakMap();
    DwebgMessage.Records = Records;
    class QueryResults extends pb_1.Message {
        constructor(data) {
            super();
            _QueryResults_one_of_decls.set(this, []);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [4], __classPrivateFieldGet(this, _QueryResults_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("batch_id" in data && data.batch_id != undefined) {
                    this.batch_id = data.batch_id;
                }
                if ("statement_id" in data && data.statement_id != undefined) {
                    this.statement_id = data.statement_id;
                }
                if ("column_names" in data && data.column_names != undefined) {
                    this.column_names = data.column_names;
                }
                if ("records" in data && data.records != undefined) {
                    this.records = data.records;
                }
            }
        }
        get batch_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set batch_id(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get statement_id() {
            return pb_1.Message.getFieldWithDefault(this, 2, "");
        }
        set statement_id(value) {
            pb_1.Message.setField(this, 2, value);
        }
        get column_names() {
            return pb_1.Message.getFieldWithDefault(this, 4, []);
        }
        set column_names(value) {
            pb_1.Message.setField(this, 4, value);
        }
        get records() {
            return pb_1.Message.getWrapperField(this, Records, 5);
        }
        set records(value) {
            pb_1.Message.setWrapperField(this, 5, value);
        }
        get has_records() {
            return pb_1.Message.getField(this, 5) != null;
        }
        static fromObject(data) {
            const message = new QueryResults({});
            if (data.batch_id != null) {
                message.batch_id = data.batch_id;
            }
            if (data.statement_id != null) {
                message.statement_id = data.statement_id;
            }
            if (data.column_names != null) {
                message.column_names = data.column_names;
            }
            if (data.records != null) {
                message.records = Records.fromObject(data.records);
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.batch_id != null) {
                data.batch_id = this.batch_id;
            }
            if (this.statement_id != null) {
                data.statement_id = this.statement_id;
            }
            if (this.column_names != null) {
                data.column_names = this.column_names;
            }
            if (this.records != null) {
                data.records = this.records.toObject();
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.batch_id.length)
                writer.writeString(1, this.batch_id);
            if (this.statement_id.length)
                writer.writeString(2, this.statement_id);
            if (this.column_names.length)
                writer.writeRepeatedString(4, this.column_names);
            if (this.has_records)
                writer.writeMessage(5, this.records, () => this.records.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new QueryResults();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.batch_id = reader.readString();
                        break;
                    case 2:
                        message.statement_id = reader.readString();
                        break;
                    case 4:
                        pb_1.Message.addToRepeatedField(message, 4, reader.readString());
                        break;
                    case 5:
                        reader.readMessage(message.records, () => message.records = Records.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return QueryResults.deserialize(bytes);
        }
    }
    _QueryResults_one_of_decls = new WeakMap();
    DwebgMessage.QueryResults = QueryResults;
    class QueryError extends pb_1.Message {
        constructor(data) {
            super();
            _QueryError_one_of_decls.set(this, [[5]]);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _QueryError_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("batch_id" in data && data.batch_id != undefined) {
                    this.batch_id = data.batch_id;
                }
                if ("statement_id" in data && data.statement_id != undefined) {
                    this.statement_id = data.statement_id;
                }
                if ("error" in data && data.error != undefined) {
                    this.error = data.error;
                }
                if ("cause" in data && data.cause != undefined) {
                    this.cause = data.cause;
                }
                if ("db_error_code" in data && data.db_error_code != undefined) {
                    this.db_error_code = data.db_error_code;
                }
            }
        }
        get batch_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set batch_id(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get statement_id() {
            return pb_1.Message.getFieldWithDefault(this, 2, "");
        }
        set statement_id(value) {
            pb_1.Message.setField(this, 2, value);
        }
        get error() {
            return pb_1.Message.getFieldWithDefault(this, 3, "");
        }
        set error(value) {
            pb_1.Message.setField(this, 3, value);
        }
        get cause() {
            return pb_1.Message.getFieldWithDefault(this, 4, QueryCause.QUERY_CAUSE_UNKNOWN);
        }
        set cause(value) {
            pb_1.Message.setField(this, 4, value);
        }
        get db_error_code() {
            return pb_1.Message.getFieldWithDefault(this, 5, "");
        }
        set db_error_code(value) {
            pb_1.Message.setOneofField(this, 5, __classPrivateFieldGet(this, _QueryError_one_of_decls, "f")[0], value);
        }
        get has_db_error_code() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get _db_error_code() {
            const cases = {
                0: "none",
                5: "db_error_code"
            };
            return cases[pb_1.Message.computeOneofCase(this, [5])];
        }
        static fromObject(data) {
            const message = new QueryError({});
            if (data.batch_id != null) {
                message.batch_id = data.batch_id;
            }
            if (data.statement_id != null) {
                message.statement_id = data.statement_id;
            }
            if (data.error != null) {
                message.error = data.error;
            }
            if (data.cause != null) {
                message.cause = data.cause;
            }
            if (data.db_error_code != null) {
                message.db_error_code = data.db_error_code;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.batch_id != null) {
                data.batch_id = this.batch_id;
            }
            if (this.statement_id != null) {
                data.statement_id = this.statement_id;
            }
            if (this.error != null) {
                data.error = this.error;
            }
            if (this.cause != null) {
                data.cause = this.cause;
            }
            if (this.db_error_code != null) {
                data.db_error_code = this.db_error_code;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.batch_id.length)
                writer.writeString(1, this.batch_id);
            if (this.statement_id.length)
                writer.writeString(2, this.statement_id);
            if (this.error.length)
                writer.writeString(3, this.error);
            if (this.cause != QueryCause.QUERY_CAUSE_UNKNOWN)
                writer.writeEnum(4, this.cause);
            if (this.has_db_error_code)
                writer.writeString(5, this.db_error_code);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new QueryError();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.batch_id = reader.readString();
                        break;
                    case 2:
                        message.statement_id = reader.readString();
                        break;
                    case 3:
                        message.error = reader.readString();
                        break;
                    case 4:
                        message.cause = reader.readEnum();
                        break;
                    case 5:
                        message.db_error_code = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return QueryError.deserialize(bytes);
        }
    }
    _QueryError_one_of_decls = new WeakMap();
    DwebgMessage.QueryError = QueryError;
    class CancelBatchQuery extends pb_1.Message {
        constructor(data) {
            super();
            _CancelBatchQuery_one_of_decls.set(this, []);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [3], __classPrivateFieldGet(this, _CancelBatchQuery_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("request_id" in data && data.request_id != undefined) {
                    this.request_id = data.request_id;
                }
                if ("batch_id" in data && data.batch_id != undefined) {
                    this.batch_id = data.batch_id;
                }
                if ("statement_ids" in data && data.statement_ids != undefined) {
                    this.statement_ids = data.statement_ids;
                }
            }
        }
        get request_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set request_id(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get batch_id() {
            return pb_1.Message.getFieldWithDefault(this, 2, "");
        }
        set batch_id(value) {
            pb_1.Message.setField(this, 2, value);
        }
        get statement_ids() {
            return pb_1.Message.getFieldWithDefault(this, 3, []);
        }
        set statement_ids(value) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data) {
            const message = new CancelBatchQuery({});
            if (data.request_id != null) {
                message.request_id = data.request_id;
            }
            if (data.batch_id != null) {
                message.batch_id = data.batch_id;
            }
            if (data.statement_ids != null) {
                message.statement_ids = data.statement_ids;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.request_id != null) {
                data.request_id = this.request_id;
            }
            if (this.batch_id != null) {
                data.batch_id = this.batch_id;
            }
            if (this.statement_ids != null) {
                data.statement_ids = this.statement_ids;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.request_id.length)
                writer.writeString(1, this.request_id);
            if (this.batch_id.length)
                writer.writeString(2, this.batch_id);
            if (this.statement_ids.length)
                writer.writeRepeatedString(3, this.statement_ids);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CancelBatchQuery();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.request_id = reader.readString();
                        break;
                    case 2:
                        message.batch_id = reader.readString();
                        break;
                    case 3:
                        pb_1.Message.addToRepeatedField(message, 3, reader.readString());
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return CancelBatchQuery.deserialize(bytes);
        }
    }
    _CancelBatchQuery_one_of_decls = new WeakMap();
    DwebgMessage.CancelBatchQuery = CancelBatchQuery;
    class ListenChannel extends pb_1.Message {
        constructor(data) {
            super();
            _ListenChannel_one_of_decls.set(this, [[2]]);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _ListenChannel_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("channel" in data && data.channel != undefined) {
                    this.channel = data.channel;
                }
                if ("payload_pattern" in data && data.payload_pattern != undefined) {
                    this.payload_pattern = data.payload_pattern;
                }
            }
        }
        get channel() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set channel(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get payload_pattern() {
            return pb_1.Message.getFieldWithDefault(this, 2, "");
        }
        set payload_pattern(value) {
            pb_1.Message.setOneofField(this, 2, __classPrivateFieldGet(this, _ListenChannel_one_of_decls, "f")[0], value);
        }
        get has_payload_pattern() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get _payload_pattern() {
            const cases = {
                0: "none",
                2: "payload_pattern"
            };
            return cases[pb_1.Message.computeOneofCase(this, [2])];
        }
        static fromObject(data) {
            const message = new ListenChannel({});
            if (data.channel != null) {
                message.channel = data.channel;
            }
            if (data.payload_pattern != null) {
                message.payload_pattern = data.payload_pattern;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.channel != null) {
                data.channel = this.channel;
            }
            if (this.payload_pattern != null) {
                data.payload_pattern = this.payload_pattern;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.channel.length)
                writer.writeString(1, this.channel);
            if (this.has_payload_pattern)
                writer.writeString(2, this.payload_pattern);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListenChannel();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.channel = reader.readString();
                        break;
                    case 2:
                        message.payload_pattern = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return ListenChannel.deserialize(bytes);
        }
    }
    _ListenChannel_one_of_decls = new WeakMap();
    DwebgMessage.ListenChannel = ListenChannel;
    class Subscribe extends pb_1.Message {
        constructor(data) {
            super();
            _Subscribe_one_of_decls.set(this, [[4], [5], [6], [9], [10], [11]]);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [3, 8], __classPrivateFieldGet(this, _Subscribe_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscribe_id" in data && data.subscribe_id != undefined) {
                    this.subscribe_id = data.subscribe_id;
                }
                if ("statement" in data && data.statement != undefined) {
                    this.statement = data.statement;
                }
                if ("parameters" in data && data.parameters != undefined) {
                    this.parameters = data.parameters;
                }
                if ("server" in data && data.server != undefined) {
                    this.server = data.server;
                }
                if ("database" in data && data.database != undefined) {
                    this.database = data.database;
                }
                if ("schema" in data && data.schema != undefined) {
                    this.schema = data.schema;
                }
                if ("mode" in data && data.mode != undefined) {
                    this.mode = data.mode;
                }
                if ("channels" in data && data.channels != undefined) {
                    this.channels = data.channels;
                }
                if ("updated_at_column" in data && data.updated_at_column != undefined) {
                    this.updated_at_column = data.updated_at_column;
                }
                if ("poll_interval_seconds" in data && data.poll_interval_seconds != undefined) {
                    this.poll_interval_seconds = data.poll_interval_seconds;
                }
                if ("poll_offset_millis" in data && data.poll_offset_millis != undefined) {
                    this.poll_offset_millis = data.poll_offset_millis;
                }
                if ("skip_column_names" in data && data.skip_column_names != undefined) {
                    this.skip_column_names = data.skip_column_names;
                }
            }
        }
        get subscribe_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set subscribe_id(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get statement() {
            return pb_1.Message.getFieldWithDefault(this, 2, "");
        }
        set statement(value) {
            pb_1.Message.setField(this, 2, value);
        }
        get parameters() {
            return pb_1.Message.getRepeatedWrapperField(this, Value, 3);
        }
        set parameters(value) {
            pb_1.Message.setRepeatedWrapperField(this, 3, value);
        }
        get server() {
            return pb_1.Message.getFieldWithDefault(this, 4, "");
        }
        set server(value) {
            pb_1.Message.setOneofField(this, 4, __classPrivateFieldGet(this, _Subscribe_one_of_decls, "f")[0], value);
        }
        get has_server() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get database() {
            return pb_1.Message.getFieldWithDefault(this, 5, "");
        }
        set database(value) {
            pb_1.Message.setOneofField(this, 5, __classPrivateFieldGet(this, _Subscribe_one_of_decls, "f")[1], value);
        }
        get has_database() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get schema() {
            return pb_1.Message.getFieldWithDefault(this, 6, "");
        }
        set schema(value) {
            pb_1.Message.setOneofField(this, 6, __classPrivateFieldGet(this, _Subscribe_one_of_decls, "f")[2], value);
        }
        get has_schema() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get mode() {
            return pb_1.Message.getFieldWithDefault(this, 7, SubscribeMode.SUBSCRIBE_MODE_ONGOING);
        }
        set mode(value) {
            pb_1.Message.setField(this, 7, value);
        }
        get channels() {
            return pb_1.Message.getRepeatedWrapperField(this, ListenChannel, 8);
        }
        set channels(value) {
            pb_1.Message.setRepeatedWrapperField(this, 8, value);
        }
        get updated_at_column() {
            return pb_1.Message.getFieldWithDefault(this, 9, "");
        }
        set updated_at_column(value) {
            pb_1.Message.setOneofField(this, 9, __classPrivateFieldGet(this, _Subscribe_one_of_decls, "f")[3], value);
        }
        get has_updated_at_column() {
            return pb_1.Message.getField(this, 9) != null;
        }
        get poll_interval_seconds() {
            return pb_1.Message.getFieldWithDefault(this, 10, 0);
        }
        set poll_interval_seconds(value) {
            pb_1.Message.setOneofField(this, 10, __classPrivateFieldGet(this, _Subscribe_one_of_decls, "f")[4], value);
        }
        get has_poll_interval_seconds() {
            return pb_1.Message.getField(this, 10) != null;
        }
        get poll_offset_millis() {
            return pb_1.Message.getFieldWithDefault(this, 11, 0);
        }
        set poll_offset_millis(value) {
            pb_1.Message.setOneofField(this, 11, __classPrivateFieldGet(this, _Subscribe_one_of_decls, "f")[5], value);
        }
        get has_poll_offset_millis() {
            return pb_1.Message.getField(this, 11) != null;
        }
        get skip_column_names() {
            return pb_1.Message.getFieldWithDefault(this, 14, false);
        }
        set skip_column_names(value) {
            pb_1.Message.setField(this, 14, value);
        }
        get _server() {
            const cases = {
                0: "none",
                4: "server"
            };
            return cases[pb_1.Message.computeOneofCase(this, [4])];
        }
        get _database() {
            const cases = {
                0: "none",
                5: "database"
            };
            return cases[pb_1.Message.computeOneofCase(this, [5])];
        }
        get _schema() {
            const cases = {
                0: "none",
                6: "schema"
            };
            return cases[pb_1.Message.computeOneofCase(this, [6])];
        }
        get _updated_at_column() {
            const cases = {
                0: "none",
                9: "updated_at_column"
            };
            return cases[pb_1.Message.computeOneofCase(this, [9])];
        }
        get _poll_interval_seconds() {
            const cases = {
                0: "none",
                10: "poll_interval_seconds"
            };
            return cases[pb_1.Message.computeOneofCase(this, [10])];
        }
        get _poll_offset_millis() {
            const cases = {
                0: "none",
                11: "poll_offset_millis"
            };
            return cases[pb_1.Message.computeOneofCase(this, [11])];
        }
        static fromObject(data) {
            const message = new Subscribe({});
            if (data.subscribe_id != null) {
                message.subscribe_id = data.subscribe_id;
            }
            if (data.statement != null) {
                message.statement = data.statement;
            }
            if (data.parameters != null) {
                message.parameters = data.parameters.map(item => Value.fromObject(item));
            }
            if (data.server != null) {
                message.server = data.server;
            }
            if (data.database != null) {
                message.database = data.database;
            }
            if (data.schema != null) {
                message.schema = data.schema;
            }
            if (data.mode != null) {
                message.mode = data.mode;
            }
            if (data.channels != null) {
                message.channels = data.channels.map(item => ListenChannel.fromObject(item));
            }
            if (data.updated_at_column != null) {
                message.updated_at_column = data.updated_at_column;
            }
            if (data.poll_interval_seconds != null) {
                message.poll_interval_seconds = data.poll_interval_seconds;
            }
            if (data.poll_offset_millis != null) {
                message.poll_offset_millis = data.poll_offset_millis;
            }
            if (data.skip_column_names != null) {
                message.skip_column_names = data.skip_column_names;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.subscribe_id != null) {
                data.subscribe_id = this.subscribe_id;
            }
            if (this.statement != null) {
                data.statement = this.statement;
            }
            if (this.parameters != null) {
                data.parameters = this.parameters.map((item) => item.toObject());
            }
            if (this.server != null) {
                data.server = this.server;
            }
            if (this.database != null) {
                data.database = this.database;
            }
            if (this.schema != null) {
                data.schema = this.schema;
            }
            if (this.mode != null) {
                data.mode = this.mode;
            }
            if (this.channels != null) {
                data.channels = this.channels.map((item) => item.toObject());
            }
            if (this.updated_at_column != null) {
                data.updated_at_column = this.updated_at_column;
            }
            if (this.poll_interval_seconds != null) {
                data.poll_interval_seconds = this.poll_interval_seconds;
            }
            if (this.poll_offset_millis != null) {
                data.poll_offset_millis = this.poll_offset_millis;
            }
            if (this.skip_column_names != null) {
                data.skip_column_names = this.skip_column_names;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.subscribe_id.length)
                writer.writeString(1, this.subscribe_id);
            if (this.statement.length)
                writer.writeString(2, this.statement);
            if (this.parameters.length)
                writer.writeRepeatedMessage(3, this.parameters, (item) => item.serialize(writer));
            if (this.has_server)
                writer.writeString(4, this.server);
            if (this.has_database)
                writer.writeString(5, this.database);
            if (this.has_schema)
                writer.writeString(6, this.schema);
            if (this.mode != SubscribeMode.SUBSCRIBE_MODE_ONGOING)
                writer.writeEnum(7, this.mode);
            if (this.channels.length)
                writer.writeRepeatedMessage(8, this.channels, (item) => item.serialize(writer));
            if (this.has_updated_at_column)
                writer.writeString(9, this.updated_at_column);
            if (this.has_poll_interval_seconds)
                writer.writeInt32(10, this.poll_interval_seconds);
            if (this.has_poll_offset_millis)
                writer.writeInt32(11, this.poll_offset_millis);
            if (this.skip_column_names != false)
                writer.writeBool(14, this.skip_column_names);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Subscribe();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.subscribe_id = reader.readString();
                        break;
                    case 2:
                        message.statement = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message.parameters, () => pb_1.Message.addToRepeatedWrapperField(message, 3, Value.deserialize(reader), Value));
                        break;
                    case 4:
                        message.server = reader.readString();
                        break;
                    case 5:
                        message.database = reader.readString();
                        break;
                    case 6:
                        message.schema = reader.readString();
                        break;
                    case 7:
                        message.mode = reader.readEnum();
                        break;
                    case 8:
                        reader.readMessage(message.channels, () => pb_1.Message.addToRepeatedWrapperField(message, 8, ListenChannel.deserialize(reader), ListenChannel));
                        break;
                    case 9:
                        message.updated_at_column = reader.readString();
                        break;
                    case 10:
                        message.poll_interval_seconds = reader.readInt32();
                        break;
                    case 11:
                        message.poll_offset_millis = reader.readInt32();
                        break;
                    case 14:
                        message.skip_column_names = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return Subscribe.deserialize(bytes);
        }
    }
    _Subscribe_one_of_decls = new WeakMap();
    DwebgMessage.Subscribe = Subscribe;
    class SubscribeError extends pb_1.Message {
        constructor(data) {
            super();
            _SubscribeError_one_of_decls.set(this, [[2], [6]]);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _SubscribeError_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscribe_id" in data && data.subscribe_id != undefined) {
                    this.subscribe_id = data.subscribe_id;
                }
                if ("results_index" in data && data.results_index != undefined) {
                    this.results_index = data.results_index;
                }
                if ("error" in data && data.error != undefined) {
                    this.error = data.error;
                }
                if ("cause" in data && data.cause != undefined) {
                    this.cause = data.cause;
                }
                if ("caused_cancel" in data && data.caused_cancel != undefined) {
                    this.caused_cancel = data.caused_cancel;
                }
                if ("db_error_code" in data && data.db_error_code != undefined) {
                    this.db_error_code = data.db_error_code;
                }
            }
        }
        get subscribe_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set subscribe_id(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get results_index() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0);
        }
        set results_index(value) {
            pb_1.Message.setOneofField(this, 2, __classPrivateFieldGet(this, _SubscribeError_one_of_decls, "f")[0], value);
        }
        get has_results_index() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get error() {
            return pb_1.Message.getFieldWithDefault(this, 3, "");
        }
        set error(value) {
            pb_1.Message.setField(this, 3, value);
        }
        get cause() {
            return pb_1.Message.getFieldWithDefault(this, 4, SubscribeCause.SUBSCRIBE_CAUSE_UNKNOWN);
        }
        set cause(value) {
            pb_1.Message.setField(this, 4, value);
        }
        get caused_cancel() {
            return pb_1.Message.getFieldWithDefault(this, 5, false);
        }
        set caused_cancel(value) {
            pb_1.Message.setField(this, 5, value);
        }
        get db_error_code() {
            return pb_1.Message.getFieldWithDefault(this, 6, "");
        }
        set db_error_code(value) {
            pb_1.Message.setOneofField(this, 6, __classPrivateFieldGet(this, _SubscribeError_one_of_decls, "f")[1], value);
        }
        get has_db_error_code() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get _results_index() {
            const cases = {
                0: "none",
                2: "results_index"
            };
            return cases[pb_1.Message.computeOneofCase(this, [2])];
        }
        get _db_error_code() {
            const cases = {
                0: "none",
                6: "db_error_code"
            };
            return cases[pb_1.Message.computeOneofCase(this, [6])];
        }
        static fromObject(data) {
            const message = new SubscribeError({});
            if (data.subscribe_id != null) {
                message.subscribe_id = data.subscribe_id;
            }
            if (data.results_index != null) {
                message.results_index = data.results_index;
            }
            if (data.error != null) {
                message.error = data.error;
            }
            if (data.cause != null) {
                message.cause = data.cause;
            }
            if (data.caused_cancel != null) {
                message.caused_cancel = data.caused_cancel;
            }
            if (data.db_error_code != null) {
                message.db_error_code = data.db_error_code;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.subscribe_id != null) {
                data.subscribe_id = this.subscribe_id;
            }
            if (this.results_index != null) {
                data.results_index = this.results_index;
            }
            if (this.error != null) {
                data.error = this.error;
            }
            if (this.cause != null) {
                data.cause = this.cause;
            }
            if (this.caused_cancel != null) {
                data.caused_cancel = this.caused_cancel;
            }
            if (this.db_error_code != null) {
                data.db_error_code = this.db_error_code;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.subscribe_id.length)
                writer.writeString(1, this.subscribe_id);
            if (this.has_results_index)
                writer.writeInt32(2, this.results_index);
            if (this.error.length)
                writer.writeString(3, this.error);
            if (this.cause != SubscribeCause.SUBSCRIBE_CAUSE_UNKNOWN)
                writer.writeEnum(4, this.cause);
            if (this.caused_cancel != false)
                writer.writeBool(5, this.caused_cancel);
            if (this.has_db_error_code)
                writer.writeString(6, this.db_error_code);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SubscribeError();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.subscribe_id = reader.readString();
                        break;
                    case 2:
                        message.results_index = reader.readInt32();
                        break;
                    case 3:
                        message.error = reader.readString();
                        break;
                    case 4:
                        message.cause = reader.readEnum();
                        break;
                    case 5:
                        message.caused_cancel = reader.readBool();
                        break;
                    case 6:
                        message.db_error_code = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return SubscribeError.deserialize(bytes);
        }
    }
    _SubscribeError_one_of_decls = new WeakMap();
    DwebgMessage.SubscribeError = SubscribeError;
    class SubscribeResults extends pb_1.Message {
        constructor(data) {
            super();
            _SubscribeResults_one_of_decls.set(this, [[7]]);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [3], __classPrivateFieldGet(this, _SubscribeResults_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscribe_id" in data && data.subscribe_id != undefined) {
                    this.subscribe_id = data.subscribe_id;
                }
                if ("results_index" in data && data.results_index != undefined) {
                    this.results_index = data.results_index;
                }
                if ("column_names" in data && data.column_names != undefined) {
                    this.column_names = data.column_names;
                }
                if ("records" in data && data.records != undefined) {
                    this.records = data.records;
                }
                if ("queried_at" in data && data.queried_at != undefined) {
                    this.queried_at = data.queried_at;
                }
                if ("trigger" in data && data.trigger != undefined) {
                    this.trigger = data.trigger;
                }
                if ("notify_channel" in data && data.notify_channel != undefined) {
                    this.notify_channel = data.notify_channel;
                }
            }
        }
        get subscribe_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set subscribe_id(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get results_index() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0);
        }
        set results_index(value) {
            pb_1.Message.setField(this, 2, value);
        }
        get column_names() {
            return pb_1.Message.getFieldWithDefault(this, 3, []);
        }
        set column_names(value) {
            pb_1.Message.setField(this, 3, value);
        }
        get records() {
            return pb_1.Message.getWrapperField(this, Records, 4);
        }
        set records(value) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get has_records() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get queried_at() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 5);
        }
        set queried_at(value) {
            pb_1.Message.setWrapperField(this, 5, value);
        }
        get has_queried_at() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get trigger() {
            return pb_1.Message.getFieldWithDefault(this, 6, SubscriptionTrigger.SUBSCRIPTION_TRIGGER_UNKNOWN);
        }
        set trigger(value) {
            pb_1.Message.setField(this, 6, value);
        }
        get notify_channel() {
            return pb_1.Message.getFieldWithDefault(this, 7, "");
        }
        set notify_channel(value) {
            pb_1.Message.setOneofField(this, 7, __classPrivateFieldGet(this, _SubscribeResults_one_of_decls, "f")[0], value);
        }
        get has_notify_channel() {
            return pb_1.Message.getField(this, 7) != null;
        }
        get _notify_channel() {
            const cases = {
                0: "none",
                7: "notify_channel"
            };
            return cases[pb_1.Message.computeOneofCase(this, [7])];
        }
        static fromObject(data) {
            const message = new SubscribeResults({});
            if (data.subscribe_id != null) {
                message.subscribe_id = data.subscribe_id;
            }
            if (data.results_index != null) {
                message.results_index = data.results_index;
            }
            if (data.column_names != null) {
                message.column_names = data.column_names;
            }
            if (data.records != null) {
                message.records = Records.fromObject(data.records);
            }
            if (data.queried_at != null) {
                message.queried_at = dependency_2.google.protobuf.Timestamp.fromObject(data.queried_at);
            }
            if (data.trigger != null) {
                message.trigger = data.trigger;
            }
            if (data.notify_channel != null) {
                message.notify_channel = data.notify_channel;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.subscribe_id != null) {
                data.subscribe_id = this.subscribe_id;
            }
            if (this.results_index != null) {
                data.results_index = this.results_index;
            }
            if (this.column_names != null) {
                data.column_names = this.column_names;
            }
            if (this.records != null) {
                data.records = this.records.toObject();
            }
            if (this.queried_at != null) {
                data.queried_at = this.queried_at.toObject();
            }
            if (this.trigger != null) {
                data.trigger = this.trigger;
            }
            if (this.notify_channel != null) {
                data.notify_channel = this.notify_channel;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.subscribe_id.length)
                writer.writeString(1, this.subscribe_id);
            if (this.results_index != 0)
                writer.writeInt32(2, this.results_index);
            if (this.column_names.length)
                writer.writeRepeatedString(3, this.column_names);
            if (this.has_records)
                writer.writeMessage(4, this.records, () => this.records.serialize(writer));
            if (this.has_queried_at)
                writer.writeMessage(5, this.queried_at, () => this.queried_at.serialize(writer));
            if (this.trigger != SubscriptionTrigger.SUBSCRIPTION_TRIGGER_UNKNOWN)
                writer.writeEnum(6, this.trigger);
            if (this.has_notify_channel)
                writer.writeString(7, this.notify_channel);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SubscribeResults();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.subscribe_id = reader.readString();
                        break;
                    case 2:
                        message.results_index = reader.readInt32();
                        break;
                    case 3:
                        pb_1.Message.addToRepeatedField(message, 3, reader.readString());
                        break;
                    case 4:
                        reader.readMessage(message.records, () => message.records = Records.deserialize(reader));
                        break;
                    case 5:
                        reader.readMessage(message.queried_at, () => message.queried_at = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 6:
                        message.trigger = reader.readEnum();
                        break;
                    case 7:
                        message.notify_channel = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return SubscribeResults.deserialize(bytes);
        }
    }
    _SubscribeResults_one_of_decls = new WeakMap();
    DwebgMessage.SubscribeResults = SubscribeResults;
    class CancelSubscribe extends pb_1.Message {
        constructor(data) {
            super();
            _CancelSubscribe_one_of_decls.set(this, []);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _CancelSubscribe_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("request_id" in data && data.request_id != undefined) {
                    this.request_id = data.request_id;
                }
                if ("subscribe_id" in data && data.subscribe_id != undefined) {
                    this.subscribe_id = data.subscribe_id;
                }
            }
        }
        get request_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set request_id(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get subscribe_id() {
            return pb_1.Message.getFieldWithDefault(this, 2, "");
        }
        set subscribe_id(value) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data) {
            const message = new CancelSubscribe({});
            if (data.request_id != null) {
                message.request_id = data.request_id;
            }
            if (data.subscribe_id != null) {
                message.subscribe_id = data.subscribe_id;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.request_id != null) {
                data.request_id = this.request_id;
            }
            if (this.subscribe_id != null) {
                data.subscribe_id = this.subscribe_id;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.request_id.length)
                writer.writeString(1, this.request_id);
            if (this.subscribe_id.length)
                writer.writeString(2, this.subscribe_id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CancelSubscribe();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.request_id = reader.readString();
                        break;
                    case 2:
                        message.subscribe_id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return CancelSubscribe.deserialize(bytes);
        }
    }
    _CancelSubscribe_one_of_decls = new WeakMap();
    DwebgMessage.CancelSubscribe = CancelSubscribe;
    class CancelSubscribeError extends pb_1.Message {
        constructor(data) {
            super();
            _CancelSubscribeError_one_of_decls.set(this, []);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _CancelSubscribeError_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("request_id" in data && data.request_id != undefined) {
                    this.request_id = data.request_id;
                }
                if ("subscribe_id" in data && data.subscribe_id != undefined) {
                    this.subscribe_id = data.subscribe_id;
                }
                if ("error" in data && data.error != undefined) {
                    this.error = data.error;
                }
                if ("cause" in data && data.cause != undefined) {
                    this.cause = data.cause;
                }
            }
        }
        get request_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "");
        }
        set request_id(value) {
            pb_1.Message.setField(this, 1, value);
        }
        get subscribe_id() {
            return pb_1.Message.getFieldWithDefault(this, 2, "");
        }
        set subscribe_id(value) {
            pb_1.Message.setField(this, 2, value);
        }
        get error() {
            return pb_1.Message.getFieldWithDefault(this, 3, "");
        }
        set error(value) {
            pb_1.Message.setField(this, 3, value);
        }
        get cause() {
            return pb_1.Message.getFieldWithDefault(this, 4, CancelSubscribeCause.CANCEL_SUBSCRIBE_CAUSE_UNKNOWN);
        }
        set cause(value) {
            pb_1.Message.setField(this, 4, value);
        }
        static fromObject(data) {
            const message = new CancelSubscribeError({});
            if (data.request_id != null) {
                message.request_id = data.request_id;
            }
            if (data.subscribe_id != null) {
                message.subscribe_id = data.subscribe_id;
            }
            if (data.error != null) {
                message.error = data.error;
            }
            if (data.cause != null) {
                message.cause = data.cause;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.request_id != null) {
                data.request_id = this.request_id;
            }
            if (this.subscribe_id != null) {
                data.subscribe_id = this.subscribe_id;
            }
            if (this.error != null) {
                data.error = this.error;
            }
            if (this.cause != null) {
                data.cause = this.cause;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.request_id.length)
                writer.writeString(1, this.request_id);
            if (this.subscribe_id.length)
                writer.writeString(2, this.subscribe_id);
            if (this.error.length)
                writer.writeString(3, this.error);
            if (this.cause != CancelSubscribeCause.CANCEL_SUBSCRIBE_CAUSE_UNKNOWN)
                writer.writeEnum(4, this.cause);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CancelSubscribeError();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.request_id = reader.readString();
                        break;
                    case 2:
                        message.subscribe_id = reader.readString();
                        break;
                    case 3:
                        message.error = reader.readString();
                        break;
                    case 4:
                        message.cause = reader.readEnum();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return CancelSubscribeError.deserialize(bytes);
        }
    }
    _CancelSubscribeError_one_of_decls = new WeakMap();
    DwebgMessage.CancelSubscribeError = CancelSubscribeError;
    class IdValue extends pb_1.Message {
        constructor(data) {
            super();
            _IdValue_one_of_decls.set(this, [[2, 3, 4]]);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _IdValue_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("int" in data && data.int != undefined) {
                    this.int = data.int;
                }
                if ("string" in data && data.string != undefined) {
                    this.string = data.string;
                }
                if ("uuid" in data && data.uuid != undefined) {
                    this.uuid = data.uuid;
                }
            }
        }
        get int() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0);
        }
        set int(value) {
            pb_1.Message.setOneofField(this, 2, __classPrivateFieldGet(this, _IdValue_one_of_decls, "f")[0], value);
        }
        get has_int() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get string() {
            return pb_1.Message.getFieldWithDefault(this, 3, "");
        }
        set string(value) {
            pb_1.Message.setOneofField(this, 3, __classPrivateFieldGet(this, _IdValue_one_of_decls, "f")[0], value);
        }
        get has_string() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get uuid() {
            return pb_1.Message.getFieldWithDefault(this, 4, new Uint8Array());
        }
        set uuid(value) {
            pb_1.Message.setOneofField(this, 4, __classPrivateFieldGet(this, _IdValue_one_of_decls, "f")[0], value);
        }
        get has_uuid() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get id_value_type() {
            const cases = {
                0: "none",
                2: "int",
                3: "string",
                4: "uuid"
            };
            return cases[pb_1.Message.computeOneofCase(this, [2, 3, 4])];
        }
        static fromObject(data) {
            const message = new IdValue({});
            if (data.int != null) {
                message.int = data.int;
            }
            if (data.string != null) {
                message.string = data.string;
            }
            if (data.uuid != null) {
                message.uuid = data.uuid;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.int != null) {
                data.int = this.int;
            }
            if (this.string != null) {
                data.string = this.string;
            }
            if (this.uuid != null) {
                data.uuid = this.uuid;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.has_int)
                writer.writeInt64(2, this.int);
            if (this.has_string)
                writer.writeString(3, this.string);
            if (this.has_uuid)
                writer.writeBytes(4, this.uuid);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new IdValue();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 2:
                        message.int = reader.readInt64();
                        break;
                    case 3:
                        message.string = reader.readString();
                        break;
                    case 4:
                        message.uuid = reader.readBytes();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return IdValue.deserialize(bytes);
        }
    }
    _IdValue_one_of_decls = new WeakMap();
    DwebgMessage.IdValue = IdValue;
    class Value extends pb_1.Message {
        constructor(data) {
            super();
            _Value_one_of_decls.set(this, [[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]]);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _Value_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("null" in data && data.null != undefined) {
                    this.null = data.null;
                }
                if ("i32" in data && data.i32 != undefined) {
                    this.i32 = data.i32;
                }
                if ("i64" in data && data.i64 != undefined) {
                    this.i64 = data.i64;
                }
                if ("f64" in data && data.f64 != undefined) {
                    this.f64 = data.f64;
                }
                if ("string" in data && data.string != undefined) {
                    this.string = data.string;
                }
                if ("bool" in data && data.bool != undefined) {
                    this.bool = data.bool;
                }
                if ("bytes" in data && data.bytes != undefined) {
                    this.bytes = data.bytes;
                }
                if ("uuid" in data && data.uuid != undefined) {
                    this.uuid = data.uuid;
                }
                if ("map" in data && data.map != undefined) {
                    this.map = data.map;
                }
                if ("list" in data && data.list != undefined) {
                    this.list = data.list;
                }
                if ("timestamp" in data && data.timestamp != undefined) {
                    this.timestamp = data.timestamp;
                }
                if ("duration" in data && data.duration != undefined) {
                    this.duration = data.duration;
                }
                if ("millis_since_midnight" in data && data.millis_since_midnight != undefined) {
                    this.millis_since_midnight = data.millis_since_midnight;
                }
                if ("days_since_epoch" in data && data.days_since_epoch != undefined) {
                    this.days_since_epoch = data.days_since_epoch;
                }
            }
        }
        get null() {
            return pb_1.Message.getFieldWithDefault(this, 1, dependency_1.google.protobuf.NullValue.NULL_VALUE);
        }
        set null(value) {
            pb_1.Message.setOneofField(this, 1, __classPrivateFieldGet(this, _Value_one_of_decls, "f")[0], value);
        }
        get has_null() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get i32() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0);
        }
        set i32(value) {
            pb_1.Message.setOneofField(this, 2, __classPrivateFieldGet(this, _Value_one_of_decls, "f")[0], value);
        }
        get has_i32() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get i64() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0);
        }
        set i64(value) {
            pb_1.Message.setOneofField(this, 3, __classPrivateFieldGet(this, _Value_one_of_decls, "f")[0], value);
        }
        get has_i64() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get f64() {
            return pb_1.Message.getFieldWithDefault(this, 4, 0);
        }
        set f64(value) {
            pb_1.Message.setOneofField(this, 4, __classPrivateFieldGet(this, _Value_one_of_decls, "f")[0], value);
        }
        get has_f64() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get string() {
            return pb_1.Message.getFieldWithDefault(this, 5, "");
        }
        set string(value) {
            pb_1.Message.setOneofField(this, 5, __classPrivateFieldGet(this, _Value_one_of_decls, "f")[0], value);
        }
        get has_string() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get bool() {
            return pb_1.Message.getFieldWithDefault(this, 6, false);
        }
        set bool(value) {
            pb_1.Message.setOneofField(this, 6, __classPrivateFieldGet(this, _Value_one_of_decls, "f")[0], value);
        }
        get has_bool() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get bytes() {
            return pb_1.Message.getFieldWithDefault(this, 7, new Uint8Array());
        }
        set bytes(value) {
            pb_1.Message.setOneofField(this, 7, __classPrivateFieldGet(this, _Value_one_of_decls, "f")[0], value);
        }
        get has_bytes() {
            return pb_1.Message.getField(this, 7) != null;
        }
        get uuid() {
            return pb_1.Message.getFieldWithDefault(this, 8, new Uint8Array());
        }
        set uuid(value) {
            pb_1.Message.setOneofField(this, 8, __classPrivateFieldGet(this, _Value_one_of_decls, "f")[0], value);
        }
        get has_uuid() {
            return pb_1.Message.getField(this, 8) != null;
        }
        get map() {
            return pb_1.Message.getWrapperField(this, Map_, 9);
        }
        set map(value) {
            pb_1.Message.setOneofWrapperField(this, 9, __classPrivateFieldGet(this, _Value_one_of_decls, "f")[0], value);
        }
        get has_map() {
            return pb_1.Message.getField(this, 9) != null;
        }
        get list() {
            return pb_1.Message.getWrapperField(this, List, 10);
        }
        set list(value) {
            pb_1.Message.setOneofWrapperField(this, 10, __classPrivateFieldGet(this, _Value_one_of_decls, "f")[0], value);
        }
        get has_list() {
            return pb_1.Message.getField(this, 10) != null;
        }
        get timestamp() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 11);
        }
        set timestamp(value) {
            pb_1.Message.setOneofWrapperField(this, 11, __classPrivateFieldGet(this, _Value_one_of_decls, "f")[0], value);
        }
        get has_timestamp() {
            return pb_1.Message.getField(this, 11) != null;
        }
        get duration() {
            return pb_1.Message.getWrapperField(this, dependency_3.google.protobuf.Duration, 12);
        }
        set duration(value) {
            pb_1.Message.setOneofWrapperField(this, 12, __classPrivateFieldGet(this, _Value_one_of_decls, "f")[0], value);
        }
        get has_duration() {
            return pb_1.Message.getField(this, 12) != null;
        }
        get millis_since_midnight() {
            return pb_1.Message.getFieldWithDefault(this, 13, 0);
        }
        set millis_since_midnight(value) {
            pb_1.Message.setOneofField(this, 13, __classPrivateFieldGet(this, _Value_one_of_decls, "f")[0], value);
        }
        get has_millis_since_midnight() {
            return pb_1.Message.getField(this, 13) != null;
        }
        get days_since_epoch() {
            return pb_1.Message.getFieldWithDefault(this, 14, 0);
        }
        set days_since_epoch(value) {
            pb_1.Message.setOneofField(this, 14, __classPrivateFieldGet(this, _Value_one_of_decls, "f")[0], value);
        }
        get has_days_since_epoch() {
            return pb_1.Message.getField(this, 14) != null;
        }
        get value_type() {
            const cases = {
                0: "none",
                1: "null",
                2: "i32",
                3: "i64",
                4: "f64",
                5: "string",
                6: "bool",
                7: "bytes",
                8: "uuid",
                9: "map",
                10: "list",
                11: "timestamp",
                12: "duration",
                13: "millis_since_midnight",
                14: "days_since_epoch"
            };
            return cases[pb_1.Message.computeOneofCase(this, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14])];
        }
        static fromObject(data) {
            const message = new Value({});
            if (data.null != null) {
                message.null = data.null;
            }
            if (data.i32 != null) {
                message.i32 = data.i32;
            }
            if (data.i64 != null) {
                message.i64 = data.i64;
            }
            if (data.f64 != null) {
                message.f64 = data.f64;
            }
            if (data.string != null) {
                message.string = data.string;
            }
            if (data.bool != null) {
                message.bool = data.bool;
            }
            if (data.bytes != null) {
                message.bytes = data.bytes;
            }
            if (data.uuid != null) {
                message.uuid = data.uuid;
            }
            if (data.map != null) {
                message.map = Map_.fromObject(data.map);
            }
            if (data.list != null) {
                message.list = List.fromObject(data.list);
            }
            if (data.timestamp != null) {
                message.timestamp = dependency_2.google.protobuf.Timestamp.fromObject(data.timestamp);
            }
            if (data.duration != null) {
                message.duration = dependency_3.google.protobuf.Duration.fromObject(data.duration);
            }
            if (data.millis_since_midnight != null) {
                message.millis_since_midnight = data.millis_since_midnight;
            }
            if (data.days_since_epoch != null) {
                message.days_since_epoch = data.days_since_epoch;
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.null != null) {
                data.null = this.null;
            }
            if (this.i32 != null) {
                data.i32 = this.i32;
            }
            if (this.i64 != null) {
                data.i64 = this.i64;
            }
            if (this.f64 != null) {
                data.f64 = this.f64;
            }
            if (this.string != null) {
                data.string = this.string;
            }
            if (this.bool != null) {
                data.bool = this.bool;
            }
            if (this.bytes != null) {
                data.bytes = this.bytes;
            }
            if (this.uuid != null) {
                data.uuid = this.uuid;
            }
            if (this.map != null) {
                data.map = this.map.toObject();
            }
            if (this.list != null) {
                data.list = this.list.toObject();
            }
            if (this.timestamp != null) {
                data.timestamp = this.timestamp.toObject();
            }
            if (this.duration != null) {
                data.duration = this.duration.toObject();
            }
            if (this.millis_since_midnight != null) {
                data.millis_since_midnight = this.millis_since_midnight;
            }
            if (this.days_since_epoch != null) {
                data.days_since_epoch = this.days_since_epoch;
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.has_null)
                writer.writeEnum(1, this.null);
            if (this.has_i32)
                writer.writeInt32(2, this.i32);
            if (this.has_i64)
                writer.writeInt64(3, this.i64);
            if (this.has_f64)
                writer.writeDouble(4, this.f64);
            if (this.has_string)
                writer.writeString(5, this.string);
            if (this.has_bool)
                writer.writeBool(6, this.bool);
            if (this.has_bytes)
                writer.writeBytes(7, this.bytes);
            if (this.has_uuid)
                writer.writeBytes(8, this.uuid);
            if (this.has_map)
                writer.writeMessage(9, this.map, () => this.map.serialize(writer));
            if (this.has_list)
                writer.writeMessage(10, this.list, () => this.list.serialize(writer));
            if (this.has_timestamp)
                writer.writeMessage(11, this.timestamp, () => this.timestamp.serialize(writer));
            if (this.has_duration)
                writer.writeMessage(12, this.duration, () => this.duration.serialize(writer));
            if (this.has_millis_since_midnight)
                writer.writeUint32(13, this.millis_since_midnight);
            if (this.has_days_since_epoch)
                writer.writeInt64(14, this.days_since_epoch);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Value();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.null = reader.readEnum();
                        break;
                    case 2:
                        message.i32 = reader.readInt32();
                        break;
                    case 3:
                        message.i64 = reader.readInt64();
                        break;
                    case 4:
                        message.f64 = reader.readDouble();
                        break;
                    case 5:
                        message.string = reader.readString();
                        break;
                    case 6:
                        message.bool = reader.readBool();
                        break;
                    case 7:
                        message.bytes = reader.readBytes();
                        break;
                    case 8:
                        message.uuid = reader.readBytes();
                        break;
                    case 9:
                        reader.readMessage(message.map, () => message.map = Map_.deserialize(reader));
                        break;
                    case 10:
                        reader.readMessage(message.list, () => message.list = List.deserialize(reader));
                        break;
                    case 11:
                        reader.readMessage(message.timestamp, () => message.timestamp = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 12:
                        reader.readMessage(message.duration, () => message.duration = dependency_3.google.protobuf.Duration.deserialize(reader));
                        break;
                    case 13:
                        message.millis_since_midnight = reader.readUint32();
                        break;
                    case 14:
                        message.days_since_epoch = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return Value.deserialize(bytes);
        }
    }
    _Value_one_of_decls = new WeakMap();
    DwebgMessage.Value = Value;
    class List extends pb_1.Message {
        constructor(data) {
            super();
            _List_one_of_decls.set(this, []);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], __classPrivateFieldGet(this, _List_one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("values" in data && data.values != undefined) {
                    this.values = data.values;
                }
            }
        }
        get values() {
            return pb_1.Message.getRepeatedWrapperField(this, Value, 1);
        }
        set values(value) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        static fromObject(data) {
            const message = new List({});
            if (data.values != null) {
                message.values = data.values.map(item => Value.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.values != null) {
                data.values = this.values.map((item) => item.toObject());
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            if (this.values.length)
                writer.writeRepeatedMessage(1, this.values, (item) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new List();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.values, () => pb_1.Message.addToRepeatedWrapperField(message, 1, Value.deserialize(reader), Value));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return List.deserialize(bytes);
        }
    }
    _List_one_of_decls = new WeakMap();
    DwebgMessage.List = List;
    class Map_ extends pb_1.Message {
        constructor(data) {
            super();
            _Map__one_of_decls.set(this, []);
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], __classPrivateFieldGet(this, _Map__one_of_decls, "f"));
            if (!Array.isArray(data) && typeof data == "object") {
                if ("values" in data && data.values != undefined) {
                    this.values = data.values;
                }
            }
            if (!this.values)
                this.values = new Map();
        }
        get values() {
            return pb_1.Message.getField(this, 1);
        }
        set values(value) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data) {
            const message = new Map_({});
            if (typeof data.values == "object") {
                message.values = new Map(Object.entries(data.values).map(([key, value]) => [key, Value.fromObject(value)]));
            }
            return message;
        }
        toObject() {
            const data = {};
            if (this.values.size > 0) {
                data.values = (Object.fromEntries)((Array.from)(this.values).map(([key, value]) => [key, value.toObject()]));
            }
            return data;
        }
        serialize(w) {
            const writer = w || new pb_1.BinaryWriter();
            for (const [key, value] of this.values) {
                writer.writeMessage(1, this.values, () => {
                    writer.writeString(1, key);
                    writer.writeMessage(2, value, () => value.serialize(writer));
                });
            }
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes) {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Map_();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.values, reader, reader.readString, () => {
                            let value;
                            reader.readMessage(message, () => value = Value.deserialize(reader));
                            return value;
                        }));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary() {
            return this.serialize();
        }
        static deserializeBinary(bytes) {
            return Map_.deserialize(bytes);
        }
    }
    _Map__one_of_decls = new WeakMap();
    DwebgMessage.Map_ = Map_;
})(DwebgMessage = exports.DwebgMessage || (exports.DwebgMessage = {}));
